//=================================================
//    summary: DCP Home 視窗 -- Hook
//
//    remarks: 000 Tim 2021/11/01 Create
//             001 Tim 2021/12/23 加入 PaintedMe流程
//             002 Tim 2022/11/02 加入 多重登入 阻擋視窗 機制
//             003 Tim 2023/09/07 開啟DCPAssessmentUrl App
//                                不使用 之前 會開下載視窗的流程，改用 開其他App的新流程
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssHome from './Home.module.scss'
import './Home.css'

import ToolBarTopUnit from '../Tool/ToolBarTopUnit/ToolBarTopUnit'
import ToolBarBottomUnit from '../Tool/ToolBarBottomUnit/ToolBarBottomUnit'
import RunningPieChart from '../Tool/RunningPieChart/RunningPieChart'
import PCLWindow from '../Tool/PCLWindow/PCLWindow'
import TermsOfUseWindow from '../Tool/TermsOfUseWindow/TermsOfUseWindow'
import BulletinMsgBox from './Units/BulletinMsgBox/BulletinMsgBox'
import OpenWebWindow from '../Tool/OpenWebWindow/OpenWebWindow'
import BCAppsWindows from '../Tool/BCAppsWindows/BCAppsWindows'
import LUAssign from '../Tool/LUAssign/LUAssign'
import AssignEdit from '../Tool/AssignEdit/AssignEdit'
import AssignReport from '../Tool/AssignReport/AssignReport'
import AssignmentPracticeSheet from '../Tool/AssignmentPracticeSheet/AssignmentPracticeSheet'

import ProgressOverView from './Units/Progress/ProgressOverView/ProgressOverView'
import ProgressLessonView from './Units/Progress/ProgressLessonView/ProgressLessonView'
import ProgressStudentView from './Units/Progress/ProgressStudentView/ProgressStudentView'

// import DownloadAnotherAppWindow from '../Tool/DownloadAnotherAppWindow/DownloadAnotherAppWindow'

import SubscriptionReminder from './Units/SubscriptionReminder/SubscriptionReminder'
import EmailVerified from './Units/EmailVerified/EmailVerified'
import EmailVerifiedSuccess from './Units/EmailVerifiedSuccess/EmailVerifiedSuccess'

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {LoadingMask, 
    AlertWindow, 
    CredentialMultiInWindow, 
    ClientGatewayInPackage, 
    PackageVariablesLibs,
    AAALibs, 
    GlobalLibs, 
    NetworkLibs, 
    TimeZoneLibs,
    RoutePathLibs,
    LocalStorageLibs
} from 'bc-react-package'


// #region State Member Variables
let mintStateBookSeqNo = 0
// #endregion State Member Variables

// #region Member Variables
let mblnIfNeed2GoToApplicationHomePage = null

let mblnInitialized = false
let mintAccountRole = 0
let marrDataProcess = []
let marrAssignment = []
let mobjCallParam = null
let mintAccountID4Storage = -1
let marrStorage = [null, null, null, null]
let marrReportData = []
let mobjStudentReportData = null
let mobjProgressViewData = null

let mintProgressDropdownIndex = 0

let mintDeleteAssignmentID = 0

let marrAssignmentSource = []
let mintLastAssignmentIndex = -1

let mblnIsLoginAfter = false

let mobjShowComponentParam = null
let mfuncToolBarBottomUnitOpenSettings = null
let mfuncReGetAuthorizedAfterProcess = null
let mobjAuthorizedSubscription = null

let mobjDashboardDisplay = null

let mobjProgressLessonViewArguments = null
let mobjProgressStudentViewArguments = null
// #endregion Member Variables

// #region Enumeration
const DataProcessEnum = {
    "AccountDashboard": 0,
    "ClassAccAssignmentStatus4Teacher": 1,
    "ClassAccAssignmentStatus4Student": 2,
    "ClassNewAssignmentList": 3,
    "ClassNewAssignmentListByAcc": 4,
    "GetSubscriptionReminder": 5
}

const ProgressViewModeEnum = {
    "OverView": 0,
    "LessonView": 1,
    "StudentView": 2
}

const ExpiredStatusEnum = {
    "NotExpired": -1,
    "Expired": 1,
    "WillExpire": 2
}
// #endregion Enumeration

// #region Const
// const LIST_PAGE_SIZE_ARRAY = [25, 25, 25, 100, 100]
// #endregion Const


const COMP_NAME = "Home"

function Home(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [bookSeqNo, setBookSeqNo] = useState(window.gSession.App.BookSeqNo)
    const [dashboardCheckTime, setDashboardCheckTime] = useState(0)
    const [updateAssignmentTime, setUpdateAssignmentTime] = useState(0)
    const [reportTime, setReportTime] = useState(0)
    const [progressViewMode, setProgressViewMode] = useState(0)
    const [anchorEl4Progress, setAnchorEl4Progress] = useState(null)
    const [average4RPC, setAverage4RPC] = useState(-1)

    const [isShowPCLWindow, setIsShowPCLWindow] = useState(false)
    const [isShowTermsOfUseWindow, setIsShowTermsOfUseWindow] = useState(false)
    const [isShowBulletinMsgBox, setIsShowBulletinMsgBox] = useState(false)
    const [isShowOpenWebWindow, setIsShowOpenWebWindow] = useState(false)
    const [isShowBCAppsWindows, setIsShowBCAppsWindows] = useState(false)
    const [isShowLUAssign, setIsShowLUAssign] = useState(false)
    const [isShowAssignEdit, setIsShowAssignEdit] = useState(false)
    const [isShowAssignReport, setIsShowAssignReport] = useState(false)
    const [isShowAssignmentPracticeSheet, setIsShowAssignmentPracticeSheet] = useState(false)

    const [isShowSubscriptionReminder, setIsShowSubscriptionReminder] = useState(false)
    const [isShowEmailVerified, setIsShowEmailVerified] = useState(false)
    const [isShowEmailVerifiedSuccess, setIsShowEmailVerifiedSuccess] = useState(false)
    // const [showDownloadAnotherAppWindow, setShowDownloadAnotherAppWindow] = useState(false) // 顯示/隱藏 下載iOS App DCPAssessment

    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    const [showAlert, setShowAlert] = useState(false)
    const [alertObject, setAlertObject] = useState(null)
    const [showCredentialMultiIn, setShowCredentialMultiIn] = useState(false)
    const [credentialMultiInArguments, setCredentialMultiInArguments] = useState(null)
    // #endregion Init State

    // #region Init Ref
    let mrefProgressDropdown = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefUpdateVolumeReGetDataProcessBegin = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefUpdateVolumeReGetDataProcessBegin.current = UpdateVolumeReGetDataProcessBegin
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mblnIfNeed2GoToApplicationHomePage = RoutePathLibs.CheckIfNeed2GoToApplicationHomePage(props.history)

        console.log(COMP_NAME + ".Begin: mblnIfNeed2GoToApplicationHomePage: ", mblnIfNeed2GoToApplicationHomePage)
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)

        mintAccountRole = window.Globals.GetClassAccountRole(window.gSession.Acc.CurrentClassIndex)
        mobjDashboardDisplay = {
            "PrefixName": window.gAppUI.LBL_NA,
            "LastAccessText": "",
            "LastAccessLessonID": "",
            "LastAccessLessonIndex": -1,
            "LastAccessLUSeqNo": 0
        }

        if (mintAccountID4Storage !== window.gSession.Acc.ID)
        {
            mintAccountID4Storage = window.gSession.Acc.ID
            marrStorage = [null, null, null, null]
        } // end of if (mintAccountID4Storage !== window.gSession.Acc.ID)

        console.log(COMP_NAME + ".Begin: mintAccountRole: ", mintAccountRole)
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Update bookSeqNo
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect.bookSeqNo: ", bookSeqNo)

        mintStateBookSeqNo = bookSeqNo

        if (window.gSession.App.BookSeqNo !== bookSeqNo)
        {
            window.gSession.App.BookSeqNo = bookSeqNo
            mrefUpdateVolumeReGetDataProcessBegin.current()
        } // end of if (window.gSession.App.BookSeqNo !== bookSeqNo)
    }, [bookSeqNo])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        if (!mblnIfNeed2GoToApplicationHomePage)
        {
            let objWindowRefs = {
                OpenLoadingMask: OpenLoadingMask,
                CloseLoadingMask: CloseLoadingMask,
                ShowAlert: ShowAlert,
                ShowCredentialMultiInWindow: ShowCredentialMultiInWindow
            }
            // AAALibs.RegisterCallerWindownFuncRefs(objWindowRefs)
            GlobalLibs.RegisterCallerWindownFuncRefs(objWindowRefs)

            mrefPaintedMe.current()
        }

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            if (!mblnIfNeed2GoToApplicationHomePage)
            {
                // AAALibs.UnRegisterCallerWindownFuncRefs()
                GlobalLibs.UnRegisterCallerWindownFuncRefs()
            }
            mblnInitialized = false
            mblnIsLoginAfter = false
            mfuncToolBarBottomUnitOpenSettings = null
            mfuncReGetAuthorizedAfterProcess = null
        }
    }, [props.history])


    // #region Painted Me
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        if (
            (typeof (props.location) !== 'undefined') &&
            (props.location !== null) &&

            (typeof (props.location.state) !== 'undefined') &&
            (props.location.state !== null) &&

            (typeof (props.location.state.IsLoginAfter) !== 'undefined') &&
            (props.location.state.IsLoginAfter !== null) &&
            (props.location.state.IsLoginAfter)
            )
        {
            console.log(COMP_NAME + ".PaintedMe: props.location.state.IsLoginAfter: ", props.location.state.IsLoginAfter)

            mblnIsLoginAfter = true
        }
        else
        {
            mblnIsLoginAfter = false
        }

        if (mblnIsLoginAfter)
        {
            // 剛登入後，先檢查 親子條款 與 使用者條款 
            window.gSession.App.LoginAfterStatus = window.gLoginAfterStatusEnum.PCLWindow
            LoginAfterProcess()
        }
        else
        {
            GetDataProcessBegin()
        }
    } // end of PaintedMe
    // #endregion Painted Me

    // #region OnTapHandler
    /*===========================================
    summary: 點選 Bulletin Lesson
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function BulletinAddOnTapHandler()
    {
        console.log(COMP_NAME + ".BulletinAddOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setIsShowLUAssign(true)
    } // end of BulletinAddOnTapHandler

    /*===========================================
    summary: 點選 Bulletin Lesson
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function BulletinLessonOnTapHandler(AssignmentIndex)
    {
        console.log(COMP_NAME + ".BulletinLessonOnTapHandler: AssignmentIndex: ", AssignmentIndex)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        console.log(COMP_NAME + ".BulletinLessonOnTapHandler marrAssignmentSource: ", marrAssignmentSource[AssignmentIndex])

        let objAssignmentSource = marrAssignmentSource[AssignmentIndex]

        if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            // Teacher
            if (!window.navigator.onLine)
            {
                GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg)
            }
            else
            {
                // "Arguments": {
                //     "AssignmentSource": marrAssignmentSource[AssignmentIndex]
                // }
                mobjShowComponentParam = {
                    "Arguments": {
                        "AssignmentSource": marrAssignmentSource[AssignmentIndex]
                    }
                }
                setIsShowAssignReport(true)
            }
        }
        else if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
        {
            let objAlertObject = {
                Header: "",
                Body: "",
                ShowCloseButton: false,
                CallbackRef: null,
                Buttons: [{
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }]
            }

            // Student 
            if (
                (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow) === 0) &&
                (
                    (objAssignmentSource.LUCatSeqNo === window.gDCPLUEnum.PracticePinyinIdentification) ||
                    (objAssignmentSource.LUCatSeqNo === window.gDCPLUEnum.PracticePinyinDictation) ||
                    (objAssignmentSource.LUCatSeqNo === window.gDCPLUEnum.PracticeListening) ||
                    (objAssignmentSource.LUCatSeqNo === window.gDCPLUEnum.PracticeFluency) ||
                    (objAssignmentSource.LUCatSeqNo === window.gDCPLUEnum.PracticeSpeaking) ||
                    (objAssignmentSource.LUCatSeqNo === window.gDCPLUEnum.PracticeReadingComprehension) ||
                    (objAssignmentSource.LUCatSeqNo === window.gDCPLUEnum.PracticeWritingGrammarExercises) ||
                    (objAssignmentSource.LUCatSeqNo === window.gDCPLUEnum.PracticeWritingComposition) ||
                    (objAssignmentSource.LUCatSeqNo === window.gDCPLUEnum.PracticeActivity)
                    )
            )
            {
                objAlertObject.Body = window.gAppUI.MSG_Alert_Msg_BlockedInstructorPractice
                ShowAlert(objAlertObject)
            }
            else if (
                (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionHWShow) === 0) &&
                (
                    (objAssignmentSource.LUCatSeqNo === window.gDCPLUEnum.ReviewListening) ||
                    (objAssignmentSource.LUCatSeqNo === window.gDCPLUEnum.ReviewReading) ||
                    (objAssignmentSource.LUCatSeqNo === window.gDCPLUEnum.ReviewWritingGrammarExercises) ||
                    (objAssignmentSource.LUCatSeqNo === window.gDCPLUEnum.ReviewWritingComposition) ||
                    (objAssignmentSource.LUCatSeqNo === window.gDCPLUEnum.ReviewSpeaking)
                    )
            )
            {
                objAlertObject.Body = window.gAppUI.MSG_Alert_Msg_BlockedInstructorReview
                ShowAlert(objAlertObject)
            }
            else
            {
                // 學生 轉跳到 Lesson > LU該單元
                CheckAuthorizedProcess(parseInt(objAssignmentSource.BookSeqNo), objAssignmentSource.LessonID, objAssignmentSource.LUCatSeqNo)
            }
        }
        else
        {
            // Personal 個人帳號
            CheckAuthorizedProcess(parseInt(objAssignmentSource.BookSeqNo), objAssignmentSource.LessonID, objAssignmentSource.LUCatSeqNo)
        }
    } // end of BulletinLessonOnTapHandler

    /*===========================================
    summary: 點選 Bulletin 編輯
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function BulletinEditOnTapHandler(AssignmentIndex)
    {
        console.log(COMP_NAME + ".BulletinEditOnTapHandler: AssignmentIndex: ", AssignmentIndex)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        console.log(COMP_NAME + ".BulletinEditOnTapHandler marrAssignmentSource: ", marrAssignmentSource[AssignmentIndex])

        if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            // 老師開啟 考卷資訊
            if (!window.navigator.onLine)
            {
                GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg);
            }
            else
            {
                mobjShowComponentParam = {
                    "Arguments": {
                        "AssignmentSource": marrAssignmentSource[AssignmentIndex]
                    }
                }
                setIsShowAssignEdit(true)
            }
        }
    } // end of BulletinEditOnTapHandler

    /*===========================================
    summary: 點選 Bulletin 刪除
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function BulletinDeleteOnTapHandler(AssignmentIndex)
    {
        console.log(COMP_NAME + ".BulletinDeleteOnTapHandler: AssignmentIndex: ", AssignmentIndex)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        console.log(COMP_NAME + ".BulletinDeleteOnTapHandler marrAssignmentSource: ", marrAssignmentSource[AssignmentIndex])

        let arrButton = [
            {
                Text: window.gAppUI.BTN_Cancel,
                AutoFocus: false
            },
            {
                Text: window.gAppUI.BTN_Delete,
                AutoFocus: true
            }
        ];

        mintDeleteAssignmentID = marrAssignmentSource[AssignmentIndex].NewAssignmentID

        let objAlertObject = {
            Header: window.gAppUI.PROMPT_DeleteAssignment_Title,
            Body: window.gAppUI.PROMPT_DeleteAssignment_Msg,
            CallbackRef: BulletinDeleteAlertCallBack,
            Buttons: arrButton
        }
        ShowAlert(objAlertObject)
    } // end of BulletinDeleteOnTapHandler

    /*===========================================
    summary: 點選 Bulletin 訊息
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function BulletinMessageOnTapHandler(AssignmentIndex)
    {
        console.log(COMP_NAME + ".BulletinMessageOnTapHandler: AssignmentIndex: ", AssignmentIndex)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        console.log(COMP_NAME + ".BulletinMessageOnTapHandler marrAssignmentSource: ", marrAssignmentSource[AssignmentIndex])

        mobjShowComponentParam = {
            "Message": marrAssignmentSource[AssignmentIndex].Message
        }

        setIsShowBulletinMsgBox(true)
    } // end of BulletinMessageOnTapHandler

    /*===========================================
    summary: 點選 Bulletin 觀看
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function BulletinViewOnTapHandler(AssignmentIndex)
    {
        console.log(COMP_NAME + ".BulletinViewOnTapHandler: AssignmentIndex: ", AssignmentIndex)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        console.log(COMP_NAME + ".BulletinViewOnTapHandler marrAssignmentSource: ", marrAssignmentSource[AssignmentIndex])

        mobjShowComponentParam = {
            "Message": marrAssignmentSource[AssignmentIndex].Message
        }

        setIsShowBulletinMsgBox(true)
    } // end of BulletinViewOnTapHandler

    /*===========================================
    summary: 按下 最後看過的單元
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function LastAccessOnTapHandler(LessonID, LessonIndex, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".LastAccessOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        console.log(COMP_NAME + ".LastAccessOnTapHandler: ", LessonID, LessonIndex, LUCatSeqNo)

        let intBookSeqNo = window.Globals.GetBookSeqNoFromLessonID(LessonID)

        // Go to specific Learning Unit
        CheckAuthorizedProcess(intBookSeqNo, LessonID, LUCatSeqNo)
    } // end of LastAccessOnTapHandler

    /*===========================================
    summary: 按下 最後的考卷
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function LastAssignmentOnTapHandler(AccountRole)
    {
        console.log(COMP_NAME + ".LastAssignmentOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (mintLastAssignmentIndex !== -1) &&
            (marrAssignmentSource.length > 0) &&
            (typeof (marrAssignmentSource[mintLastAssignmentIndex]) !== 'undefined') &&
            (marrAssignmentSource[mintLastAssignmentIndex] !== null) &&
            (typeof (marrAssignmentSource[mintLastAssignmentIndex].NewAssignmentID) !== 'undefined') &&
            (marrAssignmentSource[mintLastAssignmentIndex].NewAssignmentID !== null) &&
            (parseInt(marrAssignmentSource[mintLastAssignmentIndex].NewAssignmentID) > 0)
            )
        {
            if (AccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
            {
                // Teacher
                if (!window.navigator.onLine)
                {
                    GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg)
                }
                else
                {
                    mobjShowComponentParam = {
                        "Arguments": {
                            "AssignmentSource": marrAssignmentSource[mintLastAssignmentIndex]
                        }
                    }
                    setIsShowAssignReport(true)
                }
            }
            else
            {
                // Student or Personal 個人帳號
                console.log("NewAssignmentID: ", marrAssignmentSource[mintLastAssignmentIndex].NewAssignmentID)

                CheckAuthorizedProcess(parseInt(marrAssignmentSource[mintLastAssignmentIndex].BookSeqNo)
                    , marrAssignmentSource[mintLastAssignmentIndex].LessonID
                    , marrAssignmentSource[mintLastAssignmentIndex].LUCatSeqNo)
            }
        }
    } // end of LastAssignmentOnTapHandler

    /*===========================================
    summary: Progress Back 按鈕
    remarks: 000 Tim 2020/11/20 Create
    ===========================================*/
    function ProgressBackOnTapHandler()
    {
        console.log(COMP_NAME + ".ProgressBackOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        mobjProgressViewData = null
        mintProgressDropdownIndex = 0
        
        mobjProgressLessonViewArguments = null
        mobjProgressStudentViewArguments = null

        setProgressViewMode(ProgressViewModeEnum.OverView)
    } // end of ProgressBackOnTapHandler

    /*===========================================
    summary: 按下 Volume 按鈕
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function VolumeOnTapHandler(VolumeIndex)
    {
        console.log(COMP_NAME + ".VolumeOnTapHandler: VolumeIndex: ", VolumeIndex)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let intBookSeqNo = parseInt(VolumeIndex) + 1

        let intProgressViewMode = ProgressViewModeEnum.OverView
        if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            intProgressViewMode = ProgressViewModeEnum.OverView
            mintProgressDropdownIndex = 0
            mobjProgressStudentViewArguments = null
        } // end of if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        else
        {
            mobjProgressViewData = {
                "StudentIndex": -1
            }
            mobjProgressStudentViewArguments = {
                "BookSeqNo": intBookSeqNo,
                "StudentIndex": -1
            }

            if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
            {
                mobjProgressStudentViewArguments.ReportDataList = marrReportData
            } // end of if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
            else
            {
                mobjProgressStudentViewArguments.ReportData = mobjStudentReportData
            } // end of else

            intProgressViewMode = ProgressViewModeEnum.StudentView
        } // end of else

        mobjProgressLessonViewArguments = null
        
        setProgressViewMode(intProgressViewMode)
        setBookSeqNo(intBookSeqNo)
    } // end of VolumeOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    // ====== BEGIN Progress下拉選單 ======
    /*===========================================
    summary: 點選 Progress 選單
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ProgressDropdownOnTapHandler(event)
    {
        console.log(COMP_NAME + ".ProgressDropdownOnTapHandler")

        setAnchorEl4Progress(event.currentTarget)

        // 開啟 下拉選單時，滾動到 所選擇的位置      Tim20.12.11
        // 滾動位置 Index * 元件高度
        let intOffsetTop = mintProgressDropdownIndex * 35
        let objMenuDom = mrefProgressDropdown.current.querySelector(".MuiMenu-paper")
        objMenuDom.scroll({
            top: intOffsetTop,
            left: 0
        })
    } // end of ProgressDropdownOnTapHandler

    /*===========================================
    summary: 關閉 Progress 下拉選單
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ProgressDropdownCloseEventHandler()
    {
        console.log(COMP_NAME + ".ProgressDropdownCloseEventHandler")

        setAnchorEl4Progress(null)
    } // end of ProgressDropdownCloseEventHandler

    /*===========================================
    summary: 點選 Class 下拉選單 選項
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ProgressItemOnTapHandler(ItemIndex, LessonID, StateBookSeqNo)
    {
        console.log(COMP_NAME + ".ProgressItemOnTapHandler: ", ItemIndex)

        if (mintProgressDropdownIndex !== ItemIndex)
        {
            mintProgressDropdownIndex = ItemIndex

            mobjProgressStudentViewArguments = null

            if (ItemIndex === 0)
            {
                mobjProgressLessonViewArguments = null
                
                setProgressViewMode(ProgressViewModeEnum.OverView)
            }
            else
            {
                mobjProgressViewData = {
                    "LessonIndex": ItemIndex - 1,
                    "LessonID": LessonID
                }

                mobjProgressLessonViewArguments = {
                    "BookSeqNo": StateBookSeqNo,
                    "LessonIndex": mobjProgressViewData.LessonIndex,
                    "LessonID": LessonID,
                    "ReportDataList": marrReportData
                }
                setProgressViewMode(ProgressViewModeEnum.LessonView)
            }
        } // end of if (mintProgressDropdownIndex !== ItemIndex)

        ProgressDropdownCloseEventHandler()
    } // end of ProgressItemOnTapHandler
    // ====== END Progress下拉選單 ======
    // #endregion Other EventHandler

    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        setAlertObject(AlertObject)
        setShowAlert(true)
    } // end of ShowAlert

    /*===========================================
    summary: 關閉 提示視窗
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function HideAlert()
    {
        setAlertObject(null)
        setShowAlert(false)
    } // end of HideAlert

    /*===========================================
    summary: 開啟 多重登入 阻擋視窗
    remarks: 000 Tim 2022/11/02 Create
    ===========================================*/
    function ShowCredentialMultiInWindow(Title, Message)
    {
        let objCredentialMultiInArguments = {
            "Title": Title,
            "Message": Message
        }
        setCredentialMultiInArguments(objCredentialMultiInArguments)
        setShowCredentialMultiIn(true)
    } // end of ShowCredentialMultiInWindow
    // #endregion LoadingMask and Alert Functions

    // #region ComponentCallback

    // remarks: 001 Tim 2023/09/07 開啟DCPAssessmentUrl App
    //                             不使用 之前 會開下載視窗的流程，改用 開其他App的新流程
    // function DownloadAnotherAppWindowCallback(CallbackObj)
    // {
    //     console.log(COMP_NAME + ".DownloadAnotherAppWindowCallback CallbackObj: ", CallbackObj)

    //     if (CallbackObj.Action === "CloseDownloadAnotherAppWindow")
    //     {
    //         setShowDownloadAnotherAppWindow(false)
    //     }
    // }
    /*===========================================
    summary: Component 的 Callback
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function ComponentCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ComponentCallback CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "OpenLoadingMask")
        {
            OpenLoadingMask(CallbackObj.Message)
        }
        else if (CallbackObj.Action === "CloseLoadingMask")
        {
            CloseLoadingMask()
        }
        else if (CallbackObj.Action === "ShowAlertWindow")
        {
            ShowAlert(CallbackObj.AlertObject)
        }
        else if (CallbackObj.Action === "PCLConsentOnTap")
        {
            mobjCallParam = {
                "ParentLetterVersion": window.gSession.Acc.ParentLetterData.Version
            }
            AccountAcceptParentLetter()
        }
        else if (CallbackObj.Action === "PCLBackOnTap")
        {
            setIsShowPCLWindow(false)
            // if (!window.gSession.Acc.IsOAuthLogin)
            if (!AAALibs.LoginInfo.IsOAuthLogin)
            {
                AAALibs.NormalLogout()
            }
            else
            {
                AAALibs.OAuthNormalLogout(window.gSession.Acc.OAuthLoginProvider)
            }
        }
        else if (CallbackObj.Action === "TermsCancelOnTap")
        {
            setIsShowTermsOfUseWindow(false)
            // if (!window.gSession.Acc.IsOAuthLogin)
            if (!AAALibs.LoginInfo.IsOAuthLogin)
            {
                AAALibs.NormalLogout()
            }
            else
            {
                AAALibs.OAuthNormalLogout(window.gSession.Acc.OAuthLoginProvider)
            }
        }
        else if (CallbackObj.Action === "TermsAcceptOnTap")
        {
            mobjCallParam = {
                "TermsVersion": window.gSession.Acc.TermsData.Version
            }
            AccountAcceptTerms()
        }
        else if (CallbackObj.Action === "ClassesChange")
        {
            mintAccountRole = window.Globals.GetClassAccountRole(window.gSession.Acc.CurrentClassIndex)
            marrStorage = [null, null, null, null]
            mobjProgressLessonViewArguments = null
            mobjProgressStudentViewArguments = null

            setUpdateAssignmentTime(0)
            setReportTime(0)
            setProgressViewMode(ProgressViewModeEnum.OverView)

            UpdateClassReGetDataProcessBegin()
        }
        else if (CallbackObj.Action === "ClassManagementOnTap")
        {
            OpenClassManagement()
        }
        else if (CallbackObj.Action === "AssessmentsOnTap")
        {
            GoToAssessments()
        }
        else if (CallbackObj.Action === "BCAppsOnTap")
        {
            GoToBCApps()
        }
        else if (CallbackObj.Action === "HelpOnTap")
        {
            GoToHelp()
        }
        else if (CallbackObj.Action === "GetGlossaryFromAppProcessError")
        {
            let objAlertObject = {
                Header: "",
                Body: CallbackObj.ErrMsg,
                ShowCloseButton: false,
                CallbackRef: WebProductUnitAfterProcessAlertCallBack,
                Buttons: [
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: true
                    }
                ]
            }
            ShowAlert(objAlertObject)
        }
        else if (CallbackObj.Action === "CloseShowOpenWebWindow")
        {
            mobjShowComponentParam = null
            setIsShowOpenWebWindow(false)
        }
        else if (CallbackObj.Action === "CloseShowBCAppsWindows")
        {
            setIsShowBCAppsWindows(false)
        }
        else if (CallbackObj.Action === "CloseShowBulletinMsgBox")
        {
            setIsShowBulletinMsgBox(false)
        }
        else if (CallbackObj.Action === "OverViewLessonOnTap")
        {
            // OverView LessonOnTap
            CheckAuthorizedProcess(window.gSession.App.BookSeqNo, CallbackObj.LessonID, window.gDCPLUEnum.LessonGoals)
        }
        else if (CallbackObj.Action === "OverViewLessonStatusOnTap")
        {
            // OverView LessonStatusOnTap
            mobjProgressViewData = {
                "LessonIndex": CallbackObj.LessonIndex,
                "LessonID": CallbackObj.LessonID
            }

            mobjProgressStudentViewArguments = null
            mobjProgressLessonViewArguments = {
                "BookSeqNo": mintStateBookSeqNo,
                "LessonIndex": CallbackObj.LessonIndex,
                "LessonID": CallbackObj.LessonID,
                "ReportDataList": marrReportData
            }

            mintProgressDropdownIndex = (CallbackObj.LessonIndex + 1)

            setProgressViewMode(ProgressViewModeEnum.LessonView)
        }
        else if (CallbackObj.Action === "StudentNameOnTap")
        {
            // OverView StudentNameOnTap
            mobjProgressViewData = {
                "StudentIndex": CallbackObj.StudentIndex
            }
            mobjProgressStudentViewArguments = {
                "BookSeqNo": mintStateBookSeqNo,
                "StudentIndex": CallbackObj.StudentIndex
            }

            if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
            {
                mobjProgressStudentViewArguments.ReportDataList = marrReportData
            } // end of if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
            else
            {
                mobjProgressStudentViewArguments.ReportData = mobjStudentReportData
            } // end of else

            setProgressViewMode(ProgressViewModeEnum.StudentView)
        }
        else if (CallbackObj.Action === "LessonViewLessonStatusOnTap")
        {
            // LessonView LessonStatusOnTap
            mobjShowComponentParam = {
                "Arguments": {
                    "LessonID": CallbackObj.LessonID,
                    "LUCatSeqNo": CallbackObj.LUCatSeqNo,
                    "Assignee": CallbackObj.Assignee
                }
            }
            setIsShowAssignmentPracticeSheet(true)
        }
        else if (CallbackObj.Action === "StudentViewNameOnTap")
        {
            // StudentView LessonOnTap
            CheckAuthorizedProcess(window.gSession.App.BookSeqNo, CallbackObj.LessonID, window.gDCPLUEnum.LessonGoals)
        }
        else if (CallbackObj.Action === "LUStatusOnTap")
        {
            // StudentView LUStatusOnTap
            if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
            {
                if (CallbackObj.Status !== window.gNewAssignmentStatusEnum.NotSubmitted)
                {
                    mobjShowComponentParam = {
                        "Arguments": {
                            "LessonID": CallbackObj.LessonID,
                            "LUCatSeqNo": CallbackObj.LUCatSeqNo,
                            "Assignee": CallbackObj.Assignee
                        }
                    }
                    setIsShowAssignmentPracticeSheet(true)
                }
            }
            else
            {
                CheckAuthorizedProcess(window.gSession.App.BookSeqNo, CallbackObj.LessonID, CallbackObj.LUCatSeqNo)
            }
        }
        else if (CallbackObj.Action === "ProductUnitOnTap")
        {
            let objAlertObject = {
                Header: "",
                Body: window.gAppUI.MSG_Alert_Web_Subscribe_Successfully,
                ShowCloseButton: false,
                CallbackRef: WebProductUnitAfterProcessAlertCallBack,
                Buttons: [
                    {
                        Text: window.gAppUI.BTN_Cancel,
                        AutoFocus: false
                    },
                    {
                        Text: window.gAppUI.BTN_Update,
                        AutoFocus: true
                    }
                ]
            }
            ShowAlert(objAlertObject)
        }
        else if (CallbackObj.Action === "LaterOnTap")
        {
            setIsShowSubscriptionReminder(false)

            LoginAfterProcess()
        }
        else if (CallbackObj.Action === "CloseShowEmailVerified")
        {
            setIsShowEmailVerified(false)
            LoginAfterProcess()
        }
        else if (CallbackObj.Action === "CloseShowEmailVerifiedSuccess")
        {
            setIsShowEmailVerifiedSuccess(false)
            LoginAfterProcess()
        }
        else if (CallbackObj.Action === "RegisterOpenSettings")
        {
            mfuncToolBarBottomUnitOpenSettings = CallbackObj.Function
        }
        else if (CallbackObj.Action === "CloseShowLUAssign")
        {
            setIsShowLUAssign(false)

            if (CallbackObj.IsUpdate)
            {
                marrStorage = [null, null, null, null]
                mobjProgressLessonViewArguments = null
                mobjProgressStudentViewArguments = null

                setUpdateAssignmentTime(0)
                setReportTime(0)
                setProgressViewMode(ProgressViewModeEnum.OverView)

                UpdateClassReGetDataProcessBegin()
            }
        }
        else if (CallbackObj.Action === "CloseShowAssignEdit")
        {
            mobjShowComponentParam = null
            setIsShowAssignEdit(false)

            if (CallbackObj.IsUpdate)
            {
                marrStorage = [null, null, null, null]
                mobjProgressLessonViewArguments = null
                mobjProgressStudentViewArguments = null

                setUpdateAssignmentTime(0)
                setReportTime(0)
                setProgressViewMode(ProgressViewModeEnum.OverView)

                UpdateClassReGetDataProcessBegin()
            }
        }
        else if (CallbackObj.Action === "CloseShowAssignReport")
        {
            mfuncReGetAuthorizedAfterProcess = null
            mobjShowComponentParam = null
            setIsShowAssignReport(false)
        }
        else if (CallbackObj.Action === "CloseShowAssignmentPracticeSheet")
        {
            mfuncReGetAuthorizedAfterProcess = null
            mobjShowComponentParam = null
            setIsShowAssignmentPracticeSheet(false)

            // 先簡單處理，有時間再優化
            // AssignID: "13728"
            // Score: "50"
            // Status: 2
            // StudentAccID: "815"
            // TestedTime: "2022-01-22 02:03:14"
            // UserName: "KK B."
            if (CallbackObj.Dirty)
            {
                UpdateClassReGetDataProcessBegin()
            }
        }
        else if (CallbackObj.Action === "NoAuthorizedGoToSubscription")
        {
            mfuncToolBarBottomUnitOpenSettings(CallbackObj.AuthorizedSubscription)
        }
        else if (CallbackObj.Action === "RegisterReGetAuthorizedAfterProcess")
        {
            mfuncReGetAuthorizedAfterProcess = CallbackObj.Function
        }
        else if (CallbackObj.Action === "AssignReport4NoAuthorized")
        {
            if (mfuncReGetAuthorizedAfterProcess !== null)
            {
                mfuncReGetAuthorizedAfterProcess()
            }
        }
    } // end of ComponentCallback
    // #endregion ComponentCallback

    // #region AlertCallBack
    /*===========================================
    summary: 點選 Lessons 沒有授權 直接開授權頁面
    remarks: 000 Tim 2020/11/29 Create
    ===========================================*/
    function NoAuthorizedGoToSubscriptionAlertCallBack(BtnObject)
    {
        console.log(COMP_NAME + ".NoAuthorizedGoToSubscriptionAlertCallBack: BtnObject: ", BtnObject);

        if (BtnObject.index === 1) // BTN_OK
        {
            mfuncToolBarBottomUnitOpenSettings(mobjAuthorizedSubscription)
        }
        else
        {
            // 取消的話，清空資料
            mobjAuthorizedSubscription = null
        }
    } // end of NoAuthorizedGoToSubscriptionAlertCallBack

    /*===========================================
    summary: Bulletin 刪除
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function BulletinDeleteAlertCallBack(BtnObject)
    {
        console.log(COMP_NAME + ".BulletinDeleteAlertCallBack: BtnObject ", BtnObject)
        if (BtnObject.index === 1) // BTN_Delete
        {
            mobjCallParam = {
                "NewAssignmentID": mintDeleteAssignmentID
            }
            DeleteNewAssignment()
        }
        else
        {
            mintDeleteAssignmentID = 0
        }
    } // end of BulletinDeleteAlertCallBack

    /*===========================================
    summary: Web 點選購買產品 流程 提示後 CallBack
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function WebProductUnitAfterProcessAlertCallBack(BtnObject)
    {
        console.log(COMP_NAME + ".WebProductUnitAfterProcessAlertCallBack");

        if (BtnObject.index === 1) // BTN_OK
        {
            mobjCallParam = {
                "BundleID": window.gConst.BUNDLE_ID,
                "AppVersion": process.env.REACT_APP_LOG_VERSION,
                "BookCategoryID": 0                                 // 特殊處理，當 BookCategoryID = 0 是， 把 BookCategoryID 1, 3 的授權都回傳
            }
            GetAccountAuthorized()

            setIsShowSubscriptionReminder(false)
        }
    } // end of WebProductUnitAfterProcessAlertCallBack
    // #endregion AlertCallBack

    // #region Other Functions
    /*===========================================
    summary: 取得 後端資料 流程 開始 
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function GetDataProcessBegin()
    {
        console.log(COMP_NAME + ".GetDataProcessBegin")

        console.log(COMP_NAME + ".GetDataProcessBegin Acc.Class: ", window.gSession.Acc.Class)
        console.log(COMP_NAME + ".GetDataProcessBegin Acc.CurrentClassIndex: ", window.gSession.Acc.CurrentClassIndex)
        console.log(COMP_NAME + ".GetDataProcessBegin mintAccountRole: ", mintAccountRole)

        marrDataProcess = []

        if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            console.log(COMP_NAME + ".GetDataProcessBegin Teacher")
            // Teacher 老師 讀取資料
            // 1. GetAccountDashboard()
            // 2. GetClassAccAssignmentStatus4Teacher();
            // 3. GetClassNewAssignmentList();

            marrDataProcess.push(DataProcessEnum.AccountDashboard)
            marrDataProcess.push(DataProcessEnum.ClassAccAssignmentStatus4Teacher)
            marrDataProcess.push(DataProcessEnum.ClassNewAssignmentList)
        }
        else if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
        {
            // Student 學生
            marrDataProcess.push(DataProcessEnum.AccountDashboard)
            marrDataProcess.push(DataProcessEnum.ClassAccAssignmentStatus4Student)
            marrDataProcess.push(DataProcessEnum.ClassNewAssignmentListByAcc)

            // 1. GetAccountDashboard()
            // 2. GetClassAccAssignmentStatus4Student()
            // 3. GetClassNewAssignmentListByAcc()
        }
        else
        {
            // Personal 個人帳號 無Class
            marrDataProcess.push(DataProcessEnum.AccountDashboard)
            marrDataProcess.push(DataProcessEnum.ClassAccAssignmentStatus4Student)
            marrDataProcess.push(DataProcessEnum.ClassNewAssignmentListByAcc)

            // 1. GetAccountDashboard()
            // 2. GetClassAccAssignmentStatus4Student()
            // 3. GetClassNewAssignmentListByAcc()
        }

        // 如果是 登入後 從 Main進入，要多讀取 購買提示資訊(從AAA移過來)
        if (mblnIsLoginAfter)
        {
            // 4. GetSubscriptionReminder
            marrDataProcess.push(DataProcessEnum.GetSubscriptionReminder)
        } // end of if (mblnIsLoginAfter)

        ExecuteDataProcess()
    } // end of GetDataProcessBegin

    /*===========================================
    summary: 取得 後端資料 流程 結束
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function GetDataProcessEnd()
    {
        console.log(COMP_NAME + ".GetDataProcessEnd mblnIsLoginAfter: ", mblnIsLoginAfter);

        console.log(COMP_NAME + ".GetDataProcessEnd InitGCShare: ", window.gSession.App.InitGCShare)

        // Google Classroom 老師給的網址 解析   Tim22.01.13
        if (window.gSession.App.InitGCShare !== "")
        {
            let objGCShare = JSON.parse(decodeURIComponent(window.gSession.App.InitGCShare))
            console.log(COMP_NAME + ".GetDataProcessEnd objGCShare: ", objGCShare)

            if (
                (typeof (objGCShare.LessonID) !== 'undefined') &&
                (objGCShare.LessonID !== null) &&
                (objGCShare.LessonID !== "") &&
                (typeof (objGCShare.LUCatSeqNo) !== 'undefined') &&
                (objGCShare.LUCatSeqNo !== null) &&
                (parseInt(objGCShare.LUCatSeqNo) > 0)
                )
            {
                let intBookSeqNo = window.Globals.GetBookSeqNoFromLessonID(objGCShare.LessonID)

                CheckAuthorizedProcess(intBookSeqNo, objGCShare.LessonID, parseInt(objGCShare.LUCatSeqNo))
            }

            window.gSession.App.InitGCShare = ""
        }
        else if (mblnIsLoginAfter)
        {
            mblnIsLoginAfter = false
            // 取得資料後，可能有一些流程 要顯示
            // 1. 購買提示視窗
            // 2. EmailVerified
            LoginAfterProcess()
        }
    } // end of GetDataProcessEnd

    /*===========================================
    summary: 更新 Class後，重新 取得 後端資料 流程 開始 
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function UpdateClassReGetDataProcessBegin()
    {
        console.log(COMP_NAME + ".UpdateClassReGetDataProcessBegin")

        marrDataProcess = []

        if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            console.log(COMP_NAME + ".UpdateClassReGetDataProcessBegin Teacher")
            console.log(COMP_NAME + ".UpdateClassReGetDataProcessBegin Teacher marrStorage: ", marrStorage)

            // Teacher 老師 讀取資料
            // 1. GetClassAccAssignmentStatus4Teacher();
            // 2. GetClassNewAssignmentList();

            marrDataProcess.push(DataProcessEnum.ClassAccAssignmentStatus4Teacher)
            marrDataProcess.push(DataProcessEnum.ClassNewAssignmentList)
        }
        else if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
        {
            // Student 學生

            // 1. GetClassAccAssignmentStatus4Student()
            // 2. GetClassNewAssignmentListByAcc()
            marrDataProcess.push(DataProcessEnum.ClassAccAssignmentStatus4Student)
            marrDataProcess.push(DataProcessEnum.ClassNewAssignmentListByAcc)
        }
        else
        {
            // Personal 個人帳號 無Class

            // 1. GetClassAccAssignmentStatus4Student()
            // 2. GetClassNewAssignmentListByAcc()
            marrDataProcess.push(DataProcessEnum.ClassAccAssignmentStatus4Student)
            marrDataProcess.push(DataProcessEnum.ClassNewAssignmentListByAcc)
        }

        ExecuteDataProcess()
    } // end of UpdateClassReGetDataProcessBegin

    /*===========================================
    summary: 更新 Volume後，重新 取得 後端資料 流程 開始 
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function UpdateVolumeReGetDataProcessBegin()
    {
        console.log(COMP_NAME + ".UpdateVolumeReGetDataProcessBegin: ")

        marrDataProcess = []
        let intVolume = parseInt(window.gSession.App.BookSeqNo) - 1;

        console.log(COMP_NAME + ".UpdateVolumeReGetDataProcessBegin Teacher mintAccountID4Storage: ", mintAccountID4Storage)

        if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            console.log(COMP_NAME + ".UpdateVolumeReGetDataProcessBegin Teacher")
            console.log(COMP_NAME + ".UpdateVolumeReGetDataProcessBegin Teacher marrStorage: ", marrStorage)
            
            
            // Teacher 老師 讀取資料
            // 1. GetClassAccAssignmentStatus4Teacher();

            if (marrStorage[intVolume] === null)
            {
                marrDataProcess.push(DataProcessEnum.ClassAccAssignmentStatus4Teacher)
            }
            else
            {
                setReportTime(new Date().getTime())
                GetClassAccAssignmentStatus4TeacherAfterProcess()
            }
        }
        else if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
        {
            // Student 學生
            // Personal 個人帳號 無Class

            // 1. GetClassAccAssignmentStatus4Student()
            if (marrStorage[intVolume] === null)
            {
                marrDataProcess.push(DataProcessEnum.ClassAccAssignmentStatus4Student)
            }
            else
            {
                setReportTime(new Date().getTime())
                GetClassAccAssignmentStatus4StudentAfterProcess()
            }
        }

        ExecuteDataProcess()
    } // end of UpdateVolumeReGetDataProcessBegin

    /*===========================================
    summary: 取得 後端資料 個人帳號 流程 開始 
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function ExecuteDataProcess()
    {
        console.log(COMP_NAME + ".ExecuteDataProcess")

        let intClassID = -1
        if (
            (window.gSession.Acc.Class !== null) &&
            (window.gSession.Acc.Class.length > 0) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
            (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) !== 'undefined') &&
            (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID !== null)
            )
        {
            intClassID = window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID
        }

        if (marrDataProcess.length > 0)
        {
            let intDataProcess = marrDataProcess[0]

            // 繼續執行讀取資料
            switch (intDataProcess)
            {
                case DataProcessEnum.AccountDashboard:
                    mobjCallParam = {
                        "LastCheckTime": '',
                        "BookCategoryID": window.gSession.App.BookCatID
                    }
                    GetAccountDashboard()
                    break
                case DataProcessEnum.ClassAccAssignmentStatus4Teacher:
                    mobjCallParam = {
                        "ClassID": window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID,
                        "BookCategoryID": window.gSession.App.BookCatID,
                        "BookSeqNo": window.gSession.App.BookSeqNo
                    }
                    GetClassAccAssignmentStatus4Teacher()
                    break
                case DataProcessEnum.ClassAccAssignmentStatus4Student:
                    mobjCallParam = {
                        "Assignee": window.gSession.Acc.ID,
                        "ClassID": intClassID,
                        "BookCategoryID": window.gSession.App.BookCatID,
                        "BookSeqNo": window.gSession.App.BookSeqNo
                    }
                    GetClassAccAssignmentStatus4Student()
                    break
                case DataProcessEnum.ClassNewAssignmentList:
                    mobjCallParam = {
                        "ClassID": window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID,
                        "BookCategoryID": window.gSession.App.BookCatID     // 增加 BookCategoryID，支援新版    Tim16.03.09
                    }
                    GetClassNewAssignmentList()
                    break
                case DataProcessEnum.ClassNewAssignmentListByAcc:
                    mobjCallParam = {
                        "ClassID": intClassID,
                        "BookCategoryID": window.gSession.App.BookCatID,
                        "StudentAccID": window.gSession.Acc.ID
                    }
                    GetClassNewAssignmentListByAcc()
                    break
                case DataProcessEnum.GetSubscriptionReminder:
                    GetSubscriptionReminder()
                    break
                default:
                    break
            }

            // 移除 第一個 讀過的 流程
            marrDataProcess.shift()
        }
        else
        {
            // 結束
            GetDataProcessEnd()
        }
    } // end of ExecuteDataProcess

    /*===========================================
    summary: 初始化考卷列表
    remarks: 000 Tim 2021/11/02 Create
             001 Tim 2022/01/22 學生、個人身份 移除未來考卷
    ===========================================*/
    function InitAssignmentList()
    {
        marrAssignmentSource = []
        let datNowLocal = new Date()
        let datStartLocal = null

        marrAssignment.forEach((AssignmentData) => {
            datStartLocal = AssignmentData.StartDate.ToUTC()

            if (
                (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER) ||
                (datStartLocal.valueOf() < datNowLocal.valueOf())
                )
            {
                marrAssignmentSource.push(AssignmentData)
            }
        })

        // let intIndex = 0
        // let intCount = marrAssignment.length

        // first page
        // for (intIndex = 0; ((intIndex < intCount) && (intIndex < LIST_PAGE_SIZE_ARRAY[0])); intIndex++)
        // {
        //     datStartLocal = marrAssignment[intIndex].StartDate.ToUTC()

        //     if (datStartLocal.valueOf() > datNowLocal.valueOf())
        //     {
        //         marrAssignmentSource.push(marrAssignment[intIndex])
        //     }
        // } // end of for (intIndex = 0;

        console.log(COMP_NAME + ".InitAssignmentList: marrAssignmentSource: ", marrAssignmentSource)

        setUpdateAssignmentTime(new Date().getTime())

        setTimeout(function ()
        {
            UpdateCompletion(marrAssignmentSource)
        }, 100)
    } // end of InitAssignmentList

    /*===========================================
    summary: 更新完成度
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function UpdateCompletion(AssignmentList)
    {
        console.log(COMP_NAME + ".UpdateCompletion AssignmentList: ", AssignmentList)

        let floatCompletion = 0.0
        let intCompletion = -1
        let intScore = -1
        let intIndex = 0
        let intCount = AssignmentList.length
        let intNewAssignmentID = 0
        mintLastAssignmentIndex = -1

        for (intIndex = 0; intIndex < intCount; intIndex++)
        {
            if (
                (typeof (AssignmentList[intIndex].NewAssignmentID) !== 'undefined') &&
                (AssignmentList[intIndex].NewAssignmentID != null) &&
                (AssignmentList[intIndex].LUCatSeqNo != null) &&
                (parseInt(AssignmentList[intIndex].NewAssignmentID) > intNewAssignmentID)
                )
            {
                intNewAssignmentID = parseInt(AssignmentList[intIndex].NewAssignmentID)
                mintLastAssignmentIndex = intIndex
            }
        } // end of for (intIndex = 0;

        if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            // Teacher
            if (mintLastAssignmentIndex !== -1)
            {
                floatCompletion = Math.round((AssignmentList[mintLastAssignmentIndex].CompleteNum / AssignmentList[mintLastAssignmentIndex].TotalNum) * 100)
                intCompletion = parseInt(floatCompletion)
            }

            SetCompletion(intCompletion)
        }
        else
        {
            // Student or Personal 個人帳號
            if (
                (mintLastAssignmentIndex !== -1) &&
                (AssignmentList[mintLastAssignmentIndex].Score != null)
                )
            {
                intScore = parseInt(AssignmentList[mintLastAssignmentIndex].Score)
            }

            SetCompletion(intScore)
        }
    } // end of UpdateCompletion

    /*===========================================
    summary: 設定圓餅圖
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function SetCompletion(Completion)
    {
        console.log(COMP_NAME + ".SetCompletion: ", Completion)

        setAverage4RPC(Completion)
    } // end of SetCompletion

    /*===========================================
    summary: 初始化 新 學生進度表
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function InitStudentReportData(LessonData, StorageData)
    {
        console.log(COMP_NAME + ".InitStudentReportData: ", LessonData, StorageData)

        let objReportData = {}
        let intStatus = 0
        mobjStudentReportData = null

        let intIndex4Lesson = 0
        let intCount4Lesson = LessonData.length

        let arrLessonStatus = []

        objReportData = {
            "AccID": StorageData.StudentAccID,
            "FirstName": StorageData.StudentFirstName,
            "LastName": StorageData.StudentLastName,
            "LoginName": StorageData.StudentLoginName,
            "LessonStatus": [],
            "LessonSeq": [],
            "PracticePI": [],           // Practice Pinyin Identfication
            "PracticePD": [],           // Practice Pinyin Dictation
            "PracticeListening": [],    // Practice Listening
            "PracticeFluency": [],      // Practice Fluency
            "PracticeSpeaking": [],     // Practice Speaking
            "PracticeReading": [],      // Practice Reading
            "PracticeWritingGE": [],    // Practice Writing Grammar Exercises
            "PracticeWritingC": [],     // Practice Writing Composition
            "PracticeActivity": [],     // Practice Activity
            "ReviewListening": [],      // Review Listening
            "ReviewReading": [],        // Review Reading
            "ReviewWritingGE": [],      // Review Writing Grammar Exercises
            "ReviewWritingC": [],       // Review Writing Composition
            "ReviewSpeaking": []        // Review Speaking
        }

        for (intIndex4Lesson = 0; intIndex4Lesson < intCount4Lesson; intIndex4Lesson++)
        {
            // ===== New for React BEGIN =====
            // Volume1、2 有Pinyin，3、4 沒Pinyin
            arrLessonStatus = []

            if (parseInt(window.gSession.App.BookSeqNo) <= 2)
            {
                // 1 Practice Pinyin Identfication
                intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticePinyinIdentification].NewAssignmentType)
                arrLessonStatus.push(intStatus)

                // 2 Practice Pinyin Dictation
                intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticePinyinDictation].NewAssignmentType)
                arrLessonStatus.push(intStatus)
            }

            // 3 Practice Listening
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeListening].NewAssignmentType)
            arrLessonStatus.push(intStatus)

            // 14 Practice Fluency
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeFluency].NewAssignmentType)
            arrLessonStatus.push(intStatus)

            // 4 Practice Speaking
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeSpeaking].NewAssignmentType)
            arrLessonStatus.push(intStatus)

            // 5 Practice Reading
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeReading].NewAssignmentType)
            arrLessonStatus.push(intStatus)

            // 6 Practice Writing Grammar Exercises
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeGrammarExercises].NewAssignmentType)
            arrLessonStatus.push(intStatus)

            // 7 Practice Writing Composition
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeComposition].NewAssignmentType)
            arrLessonStatus.push(intStatus)

            // 8 Practice Activity
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeActivity].NewAssignmentType)
            arrLessonStatus.push(intStatus)

            // 9 Review Listening
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewListening].NewAssignmentType)
            arrLessonStatus.push(intStatus)

            // 10 Review Reading
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewReading].NewAssignmentType)
            arrLessonStatus.push(intStatus)

            // 11 Review Writing Grammar Exercises
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewGrammarExercises].NewAssignmentType)
            arrLessonStatus.push(intStatus)

            // 12 Review Writing Composition
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewComposition].NewAssignmentType)
            arrLessonStatus.push(intStatus)

            // 13 Review Speaking
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewSpeaking].NewAssignmentType)
            arrLessonStatus.push(intStatus)

            objReportData.LessonStatus.push(arrLessonStatus)
            // ===== New for React END =====

            // LessonSeq
            let strLessonSeq = LessonData[intIndex4Lesson].PrefixName.slice(7)
            objReportData.LessonSeq.push(strLessonSeq)

            // 1 Practice Pinyin Identfication
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticePinyinIdentification].NewAssignmentType)
            objReportData.PracticePI.push(intStatus)

            // 2 Practice Pinyin Dictation
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticePinyinDictation].NewAssignmentType)
            objReportData.PracticePD.push(intStatus)

            // 3 Practice Listening
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeListening].NewAssignmentType)
            objReportData.PracticeListening.push(intStatus)

            // 14 Practice Fluency
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeFluency].NewAssignmentType)
            objReportData.PracticeFluency.push(intStatus)

            // 4 Practice Speaking
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeSpeaking].NewAssignmentType)
            objReportData.PracticeSpeaking.push(intStatus)

            // 5 Practice Reading
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeReading].NewAssignmentType)
            objReportData.PracticeReading.push(intStatus)

            // 6 Practice Writing Grammar Exercises
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeGrammarExercises].NewAssignmentType)
            objReportData.PracticeWritingGE.push(intStatus)

            // 7 Practice Writing Composition
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeComposition].NewAssignmentType)
            objReportData.PracticeWritingC.push(intStatus)

            // 8 Practice Activity
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeActivity].NewAssignmentType)
            objReportData.PracticeActivity.push(intStatus)

            // 9 Review Listening
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewListening].NewAssignmentType)
            objReportData.ReviewListening.push(intStatus)

            // 10 Review Reading
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewReading].NewAssignmentType)
            objReportData.ReviewReading.push(intStatus)

            // 11 Review Writing Grammar Exercises
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewGrammarExercises].NewAssignmentType)
            objReportData.ReviewWritingGE.push(intStatus)

            // 12 Review Writing Composition
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewComposition].NewAssignmentType)
            objReportData.ReviewWritingC.push(intStatus)

            // 13 Review Speaking
            intStatus = GetSectionStatus(StorageData.StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewSpeaking].NewAssignmentType)
            objReportData.ReviewSpeaking.push(intStatus)
        } // end of for (intIndex4Lesson = 0;

        mobjStudentReportData = objReportData

        mobjProgressViewData = {
            "StudentIndex": -1
        }
        mobjProgressStudentViewArguments = {
            "BookSeqNo": mintStateBookSeqNo,
            "StudentIndex": -1
        }

        if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            mobjProgressStudentViewArguments.ReportDataList = marrReportData
        } // end of if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        else
        {
            mobjProgressStudentViewArguments.ReportData = mobjStudentReportData
        } // end of else

        setProgressViewMode(ProgressViewModeEnum.StudentView)
        setReportTime(new Date().getTime())

        console.log(COMP_NAME + ".InitStudentReportData END mobjStudentReportData: ", mobjStudentReportData)
    } // end of InitStudentReportData

    /*===========================================
    summary: 取得 單元 狀態
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetSectionStatus(StorageList, LessonID, NewAssignmentType)
    {
        console.log(COMP_NAME + ".GetSectionStatus: ");
        console.log(COMP_NAME + ".GetSectionStatus StorageList: ", StorageList);
        console.log(COMP_NAME + ".GetSectionStatus LessonID: ", LessonID);
        console.log(COMP_NAME + ".GetSectionStatus NewAssignmentType: ", NewAssignmentType);

        let intStatusOut = 0
        let intStatus = 0

        let intIndex4Storage = 0
        let intCount4Storage = StorageList.length
        let blnFound = false
        let blnCompleted = true

        intIndex4Storage = 0
        while ((!blnFound) && (intIndex4Storage < intCount4Storage))
        {
            if (
                (parseInt(StorageList[intIndex4Storage].LessonID) === parseInt(LessonID)) &&
                (parseInt(StorageList[intIndex4Storage].NewAssignmentType) === parseInt(NewAssignmentType))
                )
            {
                if (StorageList[intIndex4Storage].Data < 60)
                {
                    blnCompleted = false
                    intStatus = parseInt(StorageList[intIndex4Storage].Status)
                }
                blnFound = true
            }
            intIndex4Storage++
        } // end of while

        console.log(COMP_NAME + ".GetSectionStatus intStatus: ", intStatus);
        console.log(COMP_NAME + ".GetSectionStatus blnFound: ", blnFound);

        if ((blnFound) && (blnCompleted))
        {
            intStatusOut = window.gNewAssignmentStatusEnum.Completed
        }
        else if (blnFound)
        {
            intStatusOut = intStatus
        }
        else
        {
            intStatusOut = window.gNewAssignmentStatusEnum.NotSubmitted
        }

        return intStatusOut
    } // end of GetSectionStatus

    /*===========================================
    summary: 初始化 班級進度 資料
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function InitReportData(LessonData, StorageData)
    {
        console.log(COMP_NAME + ".InitReportData: ", LessonData, StorageData)

        let objReportData = {}
        let intStatus = 0
        marrReportData = []

        let intIndex4Student = 0
        let intCount4Student = StorageData.StudentList.length

        let intIndex4Lesson = 0
        let intCount4Lesson = LessonData.length

        let arrLessonStatus = []

        for (intIndex4Student = 0; intIndex4Student < intCount4Student; intIndex4Student++)
        {
            objReportData = {
                "AccID": StorageData.StudentList[intIndex4Student].StudentAccID,
                "FirstName": StorageData.StudentList[intIndex4Student].StudentFirstName,
                "LastName": StorageData.StudentList[intIndex4Student].StudentLastName,
                "LoginName": StorageData.StudentList[intIndex4Student].StudentLoginName,
                "LessonStatus": [],
                "LessonSeq": [],
                "PracticePI": [],           // Practice Pinyin Identfication
                "PracticePD": [],           // Practice Pinyin Dictation
                "PracticeListening": [],    // Practice Listening
                "PracticeFluency": [],      // Practice Fluency
                "PracticeSpeaking": [],     // Practice Speaking
                "PracticeReading": [],      // Practice Reading
                "PracticeWritingGE": [],    // Practice Writing Grammar Exercises
                "PracticeWritingC": [],     // Practice Writing Composition
                "PracticeActivity": [],     // Practice Activity
                "ReviewListening": [],      // Review Listening
                "ReviewReading": [],        // Review Reading
                "ReviewWritingGE": [],      // Review Writing Grammar Exercises
                "ReviewWritingC": [],       // Review Writing Composition
                "ReviewSpeaking": []        // Review Speaking
            };

            for (intIndex4Lesson = 0; intIndex4Lesson < intCount4Lesson; intIndex4Lesson++)
            {
                // ===== New for React BEGIN =====
                // Volume1、2 有Pinyin，3、4 沒Pinyin
                arrLessonStatus = []

                if (parseInt(window.gSession.App.BookSeqNo) <= 2)
                {
                    // 1 Practice Pinyin Identfication
                    intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticePinyinIdentification].NewAssignmentType)
                    arrLessonStatus.push(intStatus)

                    // 2 Practice Pinyin Dictation
                    intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticePinyinDictation].NewAssignmentType)
                    arrLessonStatus.push(intStatus)
                } // end of if (parseInt(window.gSession.App.BookSeqNo) <= 2)

                // 3 Practice Listening
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeListening].NewAssignmentType)
                arrLessonStatus.push(intStatus)

                // 14 Practice Fluency
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeFluency].NewAssignmentType)
                arrLessonStatus.push(intStatus)

                // 4 Practice Speaking
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeSpeaking].NewAssignmentType)
                arrLessonStatus.push(intStatus)

                // 5 Practice Reading
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeReading].NewAssignmentType)
                arrLessonStatus.push(intStatus)

                // 6 Practice Writing Grammar Exercises
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeGrammarExercises].NewAssignmentType)
                arrLessonStatus.push(intStatus)

                // 7 Practice Writing Composition
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeComposition].NewAssignmentType)
                arrLessonStatus.push(intStatus)

                // 8 Practice Activity
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeActivity].NewAssignmentType)
                arrLessonStatus.push(intStatus)

                // 9 Review Listening
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewListening].NewAssignmentType)
                arrLessonStatus.push(intStatus)

                // 10 Review Reading
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewReading].NewAssignmentType)
                arrLessonStatus.push(intStatus)

                // 11 Review Writing Grammar Exercises
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewGrammarExercises].NewAssignmentType)
                arrLessonStatus.push(intStatus)

                // 12 Review Writing Composition
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewComposition].NewAssignmentType)
                arrLessonStatus.push(intStatus)

                // 13 Review Speaking
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewSpeaking].NewAssignmentType)
                arrLessonStatus.push(intStatus)

                objReportData.LessonStatus.push(arrLessonStatus)
                // ===== New for React END =====


                // LessonSeq
                let strLessonSeq = LessonData[intIndex4Lesson].PrefixName.slice(7)
                objReportData.LessonSeq.push(strLessonSeq)

                if (parseInt(window.gSession.App.BookSeqNo) <= 2)
                {
                    // 1 Practice Pinyin Identfication
                    intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticePinyinIdentification].NewAssignmentType)
                    objReportData.PracticePI.push(intStatus)

                    // 2 Practice Pinyin Dictation
                    intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticePinyinDictation].NewAssignmentType)
                    objReportData.PracticePD.push(intStatus)
                }

                // 3 Practice Listening
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeListening].NewAssignmentType)
                objReportData.PracticeListening.push(intStatus)

                // 14 Practice Fluency
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeFluency].NewAssignmentType)
                objReportData.PracticeFluency.push(intStatus)

                // 4 Practice Speaking
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeSpeaking].NewAssignmentType)
                objReportData.PracticeSpeaking.push(intStatus)

                // 5 Practice Reading
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeReading].NewAssignmentType)
                objReportData.PracticeReading.push(intStatus)

                // 6 Practice Writing Grammar Exercises
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeGrammarExercises].NewAssignmentType)
                objReportData.PracticeWritingGE.push(intStatus)

                // 7 Practice Writing Composition
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeComposition].NewAssignmentType)
                objReportData.PracticeWritingC.push(intStatus)

                // 8 Practice Activity
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeActivity].NewAssignmentType)
                objReportData.PracticeActivity.push(intStatus)

                // 9 Review Listening
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewListening].NewAssignmentType)
                objReportData.ReviewListening.push(intStatus)

                // 10 Review Reading
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewReading].NewAssignmentType)
                objReportData.ReviewReading.push(intStatus)

                // 11 Review Writing Grammar Exercises
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewGrammarExercises].NewAssignmentType)
                objReportData.ReviewWritingGE.push(intStatus)

                // 12 Review Writing Composition
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewComposition].NewAssignmentType)
                objReportData.ReviewWritingC.push(intStatus)

                // 13 Review Speaking
                intStatus = GetSectionStatus(StorageData.StudentList[intIndex4Student].StorageList, LessonData[intIndex4Lesson].ID, window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewSpeaking].NewAssignmentType)
                objReportData.ReviewSpeaking.push(intStatus)
            } // end of for (intIndex4Lesson = 0;

            marrReportData.push(objReportData)
        } // end of for (intIndex4Student = 0;

        console.log("InitReportData END marrReportData: ", marrReportData)

        mobjProgressLessonViewArguments = null
        mobjProgressStudentViewArguments = null

        setProgressViewMode(ProgressViewModeEnum.OverView)
        setReportTime(new Date().getTime())
    } // end of InitReportData

    /*===========================================
    summary: 取得 Practice LU 資訊
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetPracticeLU(LUCatSeqNo)
    {
        // console.log(COMP_NAME + ".GetPracticeLU ", LUCatSeqNo);

        let objPracticeLU = null
        let intIndex = 0
        let intCount = window.garrPracticeLU.length
        let blnFound = false

        while ((!blnFound) && (intIndex < intCount))
        {
            if (window.garrPracticeLU[intIndex].LUCatSeqNo === LUCatSeqNo)
            {
                objPracticeLU = window.garrPracticeLU[intIndex]
                blnFound = true
            }
            intIndex++
        } // end of while

        return objPracticeLU
    } // end of GetPracticeLU

    /*===========================================
    summary: 沒有授權 的 後續流程，先走購買，再回到 原本選擇的Lesson
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function CheckAuthorizedProcess(BookSeqNo, LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".CheckAuthorizedProcess")

        console.log(COMP_NAME + ".CheckAuthorizedProcess: BookSeqNo: ", BookSeqNo)
        console.log(COMP_NAME + ".CheckAuthorizedProcess: LessonID: ", LessonID)
        console.log(COMP_NAME + ".CheckAuthorizedProcess: LUCatSeqNo: ", LUCatSeqNo)

        let strBookSeqNo = BookSeqNo.toString().PadLeft(2)

        let blnExpired = true
        // 如果他是 該本書 第一個 Lesson，有試用
        if (parseInt(window.gSession.App.BookDef[strBookSeqNo].Lesson[0].ID) === parseInt(LessonID))
        {
            blnExpired = false;
        }
        else
        {
            blnExpired = window.Globals.CheckAuthorized(window.gSession.Acc.AccountAuthorized, window.gSession.App.BookCatID, parseInt(strBookSeqNo))
        }

        if (!blnExpired)
        {
            // 有授權
            GotoLearningUnit(BookSeqNo, LessonID, LUCatSeqNo)
        }
        else
        {
            // 沒授權
            NoAuthorizedProcess(window.gSession.App.BookCatID, BookSeqNo, LessonID, LUCatSeqNo)
        }
    } // end of CheckAuthorizedProcess

    /*===========================================
    summary: 前往 LU的 連結
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GotoLearningUnit(BookSeqNo, LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".GotoLearningUnit: ", BookSeqNo, LessonID, LUCatSeqNo)

        // 補 需要判斷 授權 是否可以進去 LU
        // -> Lessons

        let strLessonID = LessonID.PadLeft(5)

        let objLocationState = {
            "BookSeqNo": BookSeqNo,
            "LessonID": strLessonID,
            "LUCatSeqNo": parseInt(LUCatSeqNo)
        }

        RoutePathLibs.Route2Path(props.history, "/Lessons", objLocationState)
    } // end of GotoLearningUnit

    /*===========================================
    summary: 前往 Assessments的 連結
    remarks: 000 Tim 2021/11/04 Create
             001 Tim 2023/06/14 處理 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
             003 Tim 2023/09/07 iOSNewGateway 改寫 
                                不使用 之前 會開下載視窗的流程
                                改用 開其他App的新流程
    ===========================================*/
    function GoToAssessments()
    {
        const FUNC_NAME = GoToAssessments.name
        console.log(COMP_NAME + "." + FUNC_NAME + ": ", window.gSession.Acc.Preferences)
        console.log(COMP_NAME + "." + FUNC_NAME + " Acc.Profile: ", window.gSession.Acc.Profile)

        let strTimeZoneValue = "";
        if (
            (typeof (window.gSession.Acc.Preferences) !== 'undefined') &&
            (window.gSession.Acc.Preferences !== null) &&
            (typeof (window.gSession.Acc.Preferences.TimeZone) !== 'undefined') &&
            (window.gSession.Acc.Preferences.TimeZone !== null) &&
            (window.gSession.Acc.Preferences.TimeZone !== -1)
            )
        {
            strTimeZoneValue = TimeZoneLibs.GetTimeZoneValueByID(window.gSession.Acc.Preferences.TimeZone)
        } // end of if (window.gSession.Acc.Preferences.TimeZone !== -1)
        console.log(COMP_NAME + "." + FUNC_NAME + " strTimeZoneValue: ", strTimeZoneValue)

        let intClassID = -1

        if (
            (window.gSession.Acc.CurrentClassIndex >= 0) &&
            (window.gSession.Acc.Class !== null) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) !== 'undefined') &&
            (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) > 0)
            )
        {
            intClassID = parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID)
        } // end of if (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) > 0)

        if (!window.gSession.App.InApp)
        {
            console.log(COMP_NAME + "." + FUNC_NAME + " not In App")

            // 暫時先用笨解法 轉換環境參數   Tim15.08.19
            let intEnv = GlobalLibs.GetIntEnv(window.gSession.App.Env)

            console.log(COMP_NAME + "." + FUNC_NAME + " Acc.Class: ", window.gSession.Acc.Class)

            // 增加參數 AccountID   Tim16.05.19
            let strQueryString = "Credential=" + window.gSession.Acc.Credential
            strQueryString += "&BackRoute="
            strQueryString += "&ClassName=" + window.gSession.Acc.Profile.ClassName
            strQueryString += "&LoginName=" + window.gSession.Acc.LoginName
            strQueryString += "&AccountID=" + window.gSession.Acc.ID
            strQueryString += "&CurrentClassID=" + intClassID
            strQueryString += "&TimeZone=" + strTimeZoneValue
            strQueryString += "&DST=" + window.gSession.Acc.Preferences.DST
            strQueryString += "&lang=" + window.gSession.Acc.Preferences.Lang
            strQueryString += "&Env=" + intEnv

            let strWebSiteUrl = window.gConfig.AssessmentUrl

            mobjShowComponentParam = {
                "WebSiteUrl": strWebSiteUrl,
                "ArgList": strQueryString,
                "IsAssessments": true
            }
            setIsShowOpenWebWindow(true)
        } // end of if (!window.gSession.App.InApp)
        else
        {
            // App
            console.log(COMP_NAME + "." + FUNC_NAME + " iOSNewGateway: ", window.gSession.App.iOSNewGateway)
            if (window.gSession.App.iOSNewGateway)
            {
                // 不使用 之前 會開下載視窗的流程，改用 開其他App的新流程   Tim23.09.07
                let strUrl = window.gConfig.DCPAssessmentUrl
                
                let intEnv = GlobalLibs.GetIntEnv(window.gSession.App.Env)

                let strParmsQueryString = "CurrentClassID=" + intClassID    // 可以將 CurrentClassID 傳過去，方便進入該Class
                strParmsQueryString += "&TimeZone=" + strTimeZoneValue
                strParmsQueryString += "&DST=" + window.gSession.Acc.Preferences.DST
                strParmsQueryString += "&LoginName=" + window.gSession.Acc.LoginName
                strParmsQueryString += "&AccountID=" + window.gSession.Acc.ID
                strParmsQueryString += "&Credential=" + window.gSession.Acc.Credential
                strParmsQueryString += "&Env=" + intEnv

                // In App
                var strWebSiteUrl = strUrl + "?" + strParmsQueryString
                console.log(COMP_NAME + "." + FUNC_NAME + " CallApp strWebSiteUrl: ", strWebSiteUrl)

                let intAction = window.gConst.ACTION_OPEN_BROWSER
                let strQueryString = "Action=" + intAction
                strQueryString += "&Credential=" + window.gSession.Acc.Credential
                strQueryString += "&BackRoute="
                strQueryString += "&Url=" + encodeURIComponent(strWebSiteUrl)

                console.log(COMP_NAME + "." + FUNC_NAME + " strQueryString: ", strQueryString)

                ClientGatewayInPackage.CallApp(strQueryString)

                // let intAction = window.gConst.ACTION_OPEN_ANOTHER_APP_BY_URL_SCHEMES                

                // // App                
                // let strParmsQueryString = "CurrentClassID=" + intClassID    // 可以將 CurrentClassID 傳過去，方便進入該Class
                // strParmsQueryString += "&TimeZone=" + strTimeZoneValue
                // strParmsQueryString += "&DST=" + window.gSession.Acc.Preferences.DST
                // strParmsQueryString += "&LoginName=" + window.gSession.Acc.LoginName
                // strParmsQueryString += "&AccountID=" + window.gSession.Acc.ID
                // strParmsQueryString += "&Credential=" + window.gSession.Acc.Credential
                
                // console.log(COMP_NAME + "." + FUNC_NAME + " iOSNewGateway strParmsQueryString: ", strParmsQueryString)

                // let strURL = window.gAppURLSchemes.DCPAssessment + "://?" + strParmsQueryString
                // let strQueryString = "Action=" + intAction
                // strQueryString += "&Credential=" + window.gSession.Acc.Credential
                // strQueryString += "&BackRoute="
                // strQueryString += "&AppUrl4Open=" + encodeURIComponent(strURL)

                // console.log(COMP_NAME + "." + FUNC_NAME + " iOSNewGateway strQueryString: ", strQueryString)

                // // 已有安裝 DCPAssessment App 且 可成功直接開 DCPAssessment App 時 不回傳
                // // 未安裝 DCPAssessment App時 會開啟失敗才回傳
                // // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway, BackFromAppCallbackGoToDCPAssessments)
                // ClientGatewayInPackage.CallApp(strQueryString, BackFromAppCallbackGoToDCPAssessments)
            } // end of if (window.gSession.App.iOSNewGateway)
            else
            {
                // call App (DCP)
                let intAction = window.gConst.ACTION_OPEN_DCP_ASSESSMENT

                //  可以將 CurrentClassID 傳過去，方便進入該Class
                let strQueryString = "Action=" + intAction
                strQueryString += "&Credential=" + window.gSession.Acc.Credential
                strQueryString += "&BackRoute="
                strQueryString += "&CurrentClassID=" + intClassID
                strQueryString += "&TimeZone=" + strTimeZoneValue
                strQueryString += "&DST=" + window.gSession.Acc.Preferences.DST
                strQueryString += "&ClassName=" + window.gSession.Acc.Profile.ClassName
                strQueryString += "&LoginName=" + window.gSession.Acc.LoginName
                strQueryString += "&AccountID=" + window.gSession.Acc.ID

                console.log(COMP_NAME + "." + FUNC_NAME + " strQueryString: ", strQueryString)
                // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
                ClientGatewayInPackage.CallApp(strQueryString)
            } // end of else
        } // end of else
    } // end of GoToAssessments

    // // remarks: 001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
    // // remarks: 002 Tim 2023/09/07 開啟DCPAssessmentUrl App
    // //                             不使用 之前 會開下載視窗的流程，改用 開其他App的新流程
    // function BackFromAppCallbackGoToDCPAssessments(ReturnData)
    // {
    //     console.log(COMP_NAME + ".BackFromAppCallbackGoToDCPAssessments: ", ReturnData)

    //     if (
    //         (typeof (ReturnData) !== 'undefined') &&
    //         (ReturnData !== null) &&
    //         (typeof (ReturnData.Status) !== 'undefined') &&
    //         (ReturnData.Status !== null)
    //         )
    //     {
    //         if (parseInt(ReturnData.Status) === 2)
    //         {
    //             console.log("show download another app window")
    //             // 未安裝 DCPAssessment 打開下載畫面
    //             setShowDownloadAnotherAppWindow(true)
    //         }
    //     }

    //     // window.gSession.App.AppCallbackRef = null
    // }

    /*===========================================
    summary: 開啟 BCApps
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function GoToBCApps()
    {
        console.log(COMP_NAME + ".GoToBCApps")

        setIsShowBCAppsWindows(true)
    } // end of GoToBCApps

    /*===========================================
    summary: 前往 Help的 連結
    remarks: 000 Tim 2021/11/04 Create
             001 Tim 2023/06/14 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function GoToHelp()
    {
        console.log(COMP_NAME + ".GoToHelp")

        let strWebSiteUrl = window.gConfig.HelpUrl
        
        if (!window.gSession.App.InApp)
        {
            // 另開始窗
            window.open(strWebSiteUrl)
        } // end of if (!window.gSession.App.InApp)
        else
        {
            // In App
            let intAction = window.gConst.ACTION_OPEN_BROWSER;
            let strQueryString = "Action=" + intAction
            strQueryString += "&Credential=" + window.gSession.Acc.Credential
            strQueryString += "&BackRoute="
            strQueryString += "&Url=" + encodeURIComponent(strWebSiteUrl);

            // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
            ClientGatewayInPackage.CallApp(strQueryString)
        } // end of else
    } // end of GoToHelp

    /*===========================================
    summary: 登入後的 流程
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function LoginAfterProcess()
    {
        console.log(COMP_NAME + ".LoginAfterProcess LoginAfterStatus: ", window.gSession.App.LoginAfterStatus)
        // 剛登入後，可能有一些流程 要顯示
        // 1. 親子條款視窗
        // 2. 使用者條款視窗
        // 3. 購買提示視窗
        // 4. EmailVerified

        switch (window.gSession.App.LoginAfterStatus)
        {
            case window.gLoginAfterStatusEnum.PCLWindow:            // 親子條款視窗
                window.gSession.App.LoginAfterStatus = window.gLoginAfterStatusEnum.Terms
                PCLWindowCheckProcess()
                break
            case window.gLoginAfterStatusEnum.Terms:                // 使用者條款視窗
                window.gSession.App.LoginAfterStatus = window.gLoginAfterStatusEnum.AuthorizedCheck
                TermsWindowCheckProcess()
                break
            case window.gLoginAfterStatusEnum.AuthorizedCheck:      // 授權到期提示視窗
                window.gSession.App.LoginAfterStatus = window.gLoginAfterStatusEnum.VerifyEmailSuccess
                AuthorizedCheckProcess4LoginAfter()
                break
            case window.gLoginAfterStatusEnum.VerifyEmailSuccess:   // 驗證email成功視窗
                window.gSession.App.LoginAfterStatus = window.gLoginAfterStatusEnum.VerifyEmail
                EmailVerifyCallbackProcess()
                break
            case window.gLoginAfterStatusEnum.VerifyEmail:          // 驗證email提示視窗
                window.gSession.App.LoginAfterStatus = window.gLoginAfterStatusEnum.End
                VerifyEmailCheckProcess()
                break
            case window.gLoginAfterStatusEnum.End:
            default:
                break
        }
    } // end of LoginAfterProcess

    /*===========================================
    summary: 親子條款 檢查流程
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function PCLWindowCheckProcess()
    {
        console.log(COMP_NAME + ".PCLWindowCheckProcess: ", window.gSession.Acc.ParentLetterData)

        if (
            (window.gSession.Acc.ParentLetterData !== null) &&
            (typeof (window.gSession.Acc.ParentLetterData.Version) !== 'undefined') &&
            (window.gSession.Acc.ParentLetterData.Version !== null) &&
            (window.gSession.Acc.ParentLetterData.Version !== '') &&
            (typeof (window.gSession.Acc.ParentLetterData.Url) !== 'undefined') &&
            (window.gSession.Acc.ParentLetterData.Url !== null) &&
            (window.gSession.Acc.ParentLetterData.Url !== '')
            )
        {
            setIsShowPCLWindow(true)
        }
        else
        {
            LoginAfterProcess()
        }
    } // end of PCLWindowCheckProcess

    /*===========================================
    summary: 使用者條款 檢查流程
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function TermsWindowCheckProcess()
    {
        console.log(COMP_NAME + ".TermsWindowCheckProcess")

        if (
            (window.gSession.Acc.TermsData !== null) &&
            (typeof (window.gSession.Acc.TermsData.Version) !== 'undefined') &&
            (window.gSession.Acc.TermsData.Version !== null) &&
            (window.gSession.Acc.TermsData.Version !== '') &&
            (typeof (window.gSession.Acc.TermsData.Url) !== 'undefined') &&
            (window.gSession.Acc.TermsData.Url !== null) &&
            (window.gSession.Acc.TermsData.Url !== '')
            )
        {
            setIsShowTermsOfUseWindow(true)
        }
        else
        {
            GetDataProcessBegin()
        }
    } // end of TermsWindowCheckProcess

    /*===========================================
    summary: 授權檢查流程
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function AuthorizedCheckProcess4LoginAfter()
    {
        console.log(COMP_NAME + ".AuthorizedCheckProcess4LoginAfter")

        let blnOpenSubscriptionReminder = false
        let strExpiredTime = ""
        let strCreatedTime = ""
        let intExpiredStatus = 0

        if (
            (!window.gSession.App.InApp) &&
            (window.gSession.Acc.Preferences.SRShow === 1)      // DCP 購買提醒 開關 1.On (default); 2.Off
        )
        {
            // Web時 才檢查
            console.log("Acc.AccountAuthorized: ", window.gSession.Acc.AccountAuthorized)

            let objAuthMix = GetAuthorizedEarliestExpired()

            // 測試用
            // objAuthMix.ExpiredTime = "2021-11-05 03:25:37"

            intExpiredStatus = CheckAuthorizedExpiredStatus(objAuthMix)        // -1: 沒過期， 1: 過期， 2: 快過期

            console.log("Preferences.SRShow: ", window.gSession.Acc.Preferences.SRShow)

            if (intExpiredStatus !== ExpiredStatusEnum.NotExpired)
            {
                blnOpenSubscriptionReminder = true
                strExpiredTime = objAuthMix.ExpiredTime
                strCreatedTime = objAuthMix.CreatedTime
            }
        } // end of if (!gSession.App.InApp)

        if (blnOpenSubscriptionReminder)
        {
            OpenSubscriptionReminder(strExpiredTime, intExpiredStatus, strCreatedTime)
        }
        else
        {
            LoginAfterProcess()
        }
    } // end of AuthorizedCheckProcess4LoginAfter

    /*===========================================
    summary: 取得 最早 授權 物件
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function GetAuthorizedEarliestExpired()
    {
        let arrAccountAuthorized = []
        let intIndex = 0
        let intCount = window.gSession.Acc.AccountAuthorized.length
        let intBookCategoryID = 3   // gBookCategoryIDEnum.BCCurrent: 3

        for (intIndex = 0; intIndex < intCount; intIndex++)
        {
            if (parseInt(window.gSession.Acc.AccountAuthorized[intIndex].BookCategoryID) === intBookCategoryID)
            {
                arrAccountAuthorized.push(JSON.parse(JSON.stringify(window.gSession.Acc.AccountAuthorized[intIndex])))
            }
        } // end of for (intIndex = 0;

        console.log("arrAccountAuthorized: ", arrAccountAuthorized)

        intIndex = 0
        intCount = arrAccountAuthorized.length

        let objAuthMix = arrAccountAuthorized[0]
        let objAuthCompre = arrAccountAuthorized[1]
        let datAuthMix = null
        let datAuthCompre = null

        for (intIndex = 1; intIndex < intCount; intIndex++)
        {
            objAuthCompre = arrAccountAuthorized[intIndex]

            if (
                (typeof (objAuthMix.ExpiredTime) !== 'undefined') &&
                (objAuthMix.ExpiredTime !== null) &&
                (typeof (objAuthCompre.ExpiredTime) !== 'undefined') &&
                (objAuthCompre.ExpiredTime !== null)
                )
            {
                // 到期日 用 本地時間          Tim22.12.02
                datAuthMix = objAuthMix.ExpiredTime.replace(/\//g, '-').replace('T', ' ').replace('Z', ' ').ToUTC()
                datAuthCompre = objAuthCompre.ExpiredTime.replace(/\//g, '-').replace('T', ' ').replace('Z', ' ').ToUTC()

                console.log("datAuthMix: ", datAuthMix)
                console.log("datAuthCompre: ", datAuthCompre)
                console.log("Formate datAuthMix: ", datAuthMix.FormateBCDisplayDateTime())
                console.log("Formate datAuthCompre: ", datAuthCompre.FormateBCDisplayDateTime())

                // datAuthMix、datAuthCompre 都用本地時間 LoaclTime 比較
                if (datAuthMix.getTime() >= datAuthCompre.getTime())
                {
                    objAuthMix = objAuthCompre
                } // end of if (datAuthMix.getTime() >= datAuthCompre.getTime())
            }
            else if (
                (typeof (objAuthCompre.ExpiredTime) !== 'undefined') &&
                (objAuthCompre.ExpiredTime !== null)
                )
            {
                objAuthMix = objAuthCompre
            }
        }

        console.log(COMP_NAME + ".GetAuthorizedEarliestExpired END objAuthMix: ", objAuthMix)

        return objAuthMix
    } // end of GetAuthorizedEarliestExpired

    /*===========================================
    summary: 檢查 過期狀態
    remarks: 000 Tim 2021/11/05 Create
             001 Tim 2022/12/02 比較時間 改由 轉換成 本地時間比較
    ===========================================*/
    function CheckAuthorizedExpiredStatus(AuthObject)
    {
        let intExpiredStatus = ExpiredStatusEnum.NotExpired        // -1: 沒過期， 1: 過期， 2: 快過期

        if (
            (AuthObject !== null) &&
            (typeof (AuthObject.ExpiredTime) !== 'undefined') &&
            (AuthObject.ExpiredTime !== null) &&
            (AuthObject.ExpiredTime !== "2000-01-01 00:00:00")    // 這個代表後端設定 取消授權   Tim22.12.05
            )
        {
            console.log("AuthObject.ExpiredTime: ", AuthObject.ExpiredTime)

            let datNow = new Date()
            console.log("datNow: ", datNow.toString())
            console.log("datNow: ", datNow.FormateBCDisplayDateTime())

            // 原到期日 用 本地時間          Tim22.12.02
            let datAuth = AuthObject.ExpiredTime.replace(/\//g, '-').replace('T', ' ').replace('Z', ' ').ToUTC()
            let datAuthDelay = new Date(datAuth)
            // setDate 後 會變成 getTime 格式
            // 所以 再用 new Date( 讓他變回 Date格式
            datAuthDelay = new Date(datAuthDelay.setDate(datAuth.getDate() + 1))    // 到期日多加一天緩衝
            console.log("datAuthDelay: ", datAuthDelay.toString())
            console.log("datAuthDelay: ", datAuthDelay.FormateBCDisplayDateTime())

            // ============== 1. 先檢查到期日 ==============
            // datNow、datAuthDelay 都用本地時間 LoaclTime 比較
            if (datNow.getTime() > datAuthDelay.getTime())
            {
                // 過期
                console.log("AuthorizedCheckProcess 過期")

                intExpiredStatus = ExpiredStatusEnum.Expired        // -1: 沒過期， 1: 過期， 2: 快過期
            } // end of if (datNow.getTime() > datAuthDelay.getTime())
            else
            {
                // 沒過期
                console.log("AuthorizedCheckProcess 沒過期")

                // 到期7天前提醒時間
                let datAuth7Ago = new Date(datAuth)
                // setDate 後 會變成 getTime 格式
                // 所以 再用 new Date( 讓他變回 Date格式
                datAuth7Ago = new Date(datAuth7Ago.setDate(datAuth.getDate() + (1 - 7)))
                console.log("Formate datAuth7Ago: ", datAuth7Ago.FormateBCDisplayDateTime())

                // ============== 2. 再檢查到期7天前提醒 ==============
                // datNow、datAuth7Ago 都用現實時間 LoaclTime 比較
                if (datNow.getTime() > datAuth7Ago.getTime())
                {
                    // 過期
                    console.log("AuthorizedCheckProcess 7Ago 過期")

                    intExpiredStatus = ExpiredStatusEnum.WillExpire        // -1: 沒過期， 1: 過期， 2: 快過期
                } // end of if (datNow.getTime() > datAuth7Ago.getTime())
            } // end of else
        } // end of if (AuthObject.ExpiredTime !== null)

        console.log(COMP_NAME + ".CheckAuthorizedExpiredStatus END intExpiredStatus: ", intExpiredStatus)

        return intExpiredStatus
    } // end of CheckAuthorizedExpiredStatus

    /*===========================================
    summary: 打開 SubscriptionReminder 視窗
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function OpenSubscriptionReminder(ExpiredTime, ExpiredStatus, CreatedTime)
    {
        console.log("OpenSubscriptionReminder")

        console.log("ExpiredTime: ", ExpiredTime)
        console.log("CreatedTime: ", CreatedTime)

        let datExpired = new Date(ExpiredTime.replace(/-/g, '/'))
        let blnIsTrial = false

        if (
            (typeof (CreatedTime) !== 'undefined') &&
            (CreatedTime !== null) &&
            (CreatedTime !== '')
            )
        {
            let datCreated = new Date(CreatedTime.replace(/-/g, '/'))
            let intTime = datExpired.getTime() - datCreated.getTime()

            console.log("intTime: ", intTime)
            // 時間小於 31天內，判定為 試用帳號   Tim20.05.11
            // 一小時有3,600 秒， 一天是有24 x 3,600 = 86,400 秒
            if (intTime <= (1000 * 3600 * 24 * 31))
            {
                blnIsTrial = true
            }
        }

        let strExpired = datExpired.FormateBCDisplayDate()
        mobjShowComponentParam = {
            "ExpirationDate": strExpired,
            "ExpiredStatus": ExpiredStatus,
            "IsTrial": blnIsTrial
        }

        console.log("OpenSubscriptionReminder mobjShowComponentParam: ", mobjShowComponentParam)

        setIsShowSubscriptionReminder(true)
    } // end of OpenSubscriptionReminder

    /*===========================================
    summary: 驗證 Email 檢查流程
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function VerifyEmailCheckProcess()
    {
        console.log(COMP_NAME + ".VerifyEmailCheckProcess Acc.LoginCount: ", window.gSession.Acc.LoginCount)
        console.log(COMP_NAME + ".VerifyEmailCheckProcess window.gSession.Acc.EmailVerified: ", window.gSession.Acc.EmailVerified)

        if (
            (
                (window.gSession.Acc.LoginType === AAALibs.LoginTypeEnum.UserLogin) ||
                (window.gSession.Acc.LoginType === AAALibs.LoginTypeEnum.AutoLogin) ||
                (window.gSession.Acc.LoginType === AAALibs.LoginTypeEnum.OAuthLogin)
            ) &&
            (window.gSession.Acc.EmailVerified === window.gEmailVerifyEnum.NotVerify) &&
            (window.gSession.Acc.LoginCount !== -1) &&
            ((window.gSession.Acc.LoginCount % 5) === 1)
            )
        {
            setIsShowEmailVerified(true)
        }
        else
        {
            LoginAfterProcess()
        }
    } // end of VerifyEmailCheckProcess

    /*===========================================
    summary: 從 Mail點回來 驗證 Email 流程
    remarks: 000 Tim 2021/12/ Create
    ===========================================*/
    function EmailVerifyCallbackProcess()
    {
        console.log(COMP_NAME + ".EmailVerifyCallbackProcess App.VEData: ", window.gSession.App.VEData)
        console.log(COMP_NAME + ".EmailVerifyCallbackProcess window.gSessionAcc.EmailVerified: ", window.gSession.Acc.EmailVerified)

        if (
            (window.gSession.Acc.EmailVerified === window.gEmailVerifyEnum.NotVerify) &&
            (window.gSession.App.VEData.UserKey !== "") &&
            (window.gSession.App.VEData.Code !== "") &&
            (parseInt(window.gSession.App.VEData.UserKey) === parseInt(window.gSession.Acc.ID))
            )
        {
            mobjCallParam = {
                "AccountID": window.gSession.App.VEData.UserKey,
                "Code": window.gSession.App.VEData.Code,
                "EmailAddr": window.gSession.App.VEData.EmailAddr
            }
            VerifyAccountEmail()
        }
        else
        {
            LoginAfterProcess()
        }
    } // end of EmailVerifyCallbackProcess

    /*===========================================
    summary: 沒有授權 的 後續流程，先走購買，再回到 原本選擇的Lesson
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function NoAuthorizedProcess(BookCatID, BookSeqNo, LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".NoAuthorizedProcess: Not Authorized!")

        console.log(COMP_NAME + ".NoAuthorizedProcess: BookCatID: ", BookCatID)
        console.log(COMP_NAME + ".NoAuthorizedProcess: BookSeqNo: ", BookSeqNo)
        console.log(COMP_NAME + ".NoAuthorizedProcess: LessonID: ", LessonID)
        console.log(COMP_NAME + ".NoAuthorizedProcess: LUCatSeqNo: ", LUCatSeqNo)

        // 先不串 GoogleClass 配對這塊     Tim20.04.17
        let strBookSeqNo = BookSeqNo.toString().PadLeft(2)
        mobjAuthorizedSubscription = {
            "BookCatID": parseInt(BookCatID),
            "BookSeqNo": strBookSeqNo,
            "LessonID": LessonID,
            "LUCatSeqNo": parseInt(LUCatSeqNo),
            "SubscriptionType": -1
        }

        let objAlertObject = {
            Header: "",
            Body: window.gAppUI.ERR_GoToLUNoAuthorizedGoToIAP,
            ShowCloseButton: false,
            CallbackRef: NoAuthorizedGoToSubscriptionAlertCallBack,
            Buttons: [
                {
                    Text: window.gAppUI.BTN_Cancel,
                    AutoFocus: false
                },
                {
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)
    } // end of NoAuthorizedProcess

    /*===========================================
    summary: 取得 Last Access 的顯示資料
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetLastAccessData()
    {
        console.log(COMP_NAME + ".GetLastAccessData: ", window.gSession.Acc.Dashboard)

        let objData = {
            "PrefixName": window.gAppUI.LBL_NA,
            "LastAccessText": "",
            "LastAccessLessonID": "",
            "LastAccessLessonIndex": -1,
            "LastAccessLUSeqNo": 0
        }

        if (
            (typeof (window.gSession.Acc.Dashboard) !== 'undefined') &&
            (window.gSession.Acc.Dashboard !== null) &&
            (typeof (window.gSession.Acc.Dashboard.LastAccessLessonID) !== 'undefined') &&
            (window.gSession.Acc.Dashboard.LastAccessLessonID !== null)
            )
        {
            // 有 Last Accessed
            objData.LastAccessText = ""

            let arrLessonInBook = window.gSession.App.BookDef[window.gSession.Acc.Dashboard.LastAccessBookSeqNo].Lesson
            // console.log("GetLastAccessData window.gSession.App.BookDef:", window.gSession.App.BookDef);
            // console.log("GetLastAccessData window.gSession.Acc.Dashboard:", window.gSession.Acc.Dashboard);
            // console.log("GetLastAccessData window.gSession.Acc.Dashboard.LastAccessLUSeqNo:", window.gSession.Acc.Dashboard.LastAccessLUSeqNo);
            // console.log("GetLastAccessData window.gSession.Acc.Dashboard.LastAccessLessonID:", window.gSession.Acc.Dashboard.LastAccessLessonID);

            // console.log("GetLastAccessData arrLessonInBook:", arrLessonInBook);

            let intIndex = 0
            let intCount = arrLessonInBook.length
            let blnFound = false

            while ((!blnFound) && (intIndex < intCount))
            {
                if (parseInt(arrLessonInBook[intIndex].ID) === parseInt(window.gSession.Acc.Dashboard.LastAccessLessonID))
                {
                    blnFound = true
                    objData.PrefixName = arrLessonInBook[intIndex].PrefixName
                    objData.LastAccessText = arrLessonInBook[intIndex].Name + ' ' + GetLUDisplayName(window.gSession.App.BookDef[window.gSession.Acc.Dashboard.LastAccessBookSeqNo], window.gSession.Acc.Dashboard.LastAccessSectionSeqNo, window.gSession.Acc.Dashboard.LastAccessSubSectionSeqNo, window.gSession.Acc.Dashboard.LastAccessSubSubSectionSeqNo)
                    objData.LastAccessLessonIndex = intIndex
                    objData.LastAccessLessonID = window.gSession.Acc.Dashboard.LastAccessLessonID
                    objData.LastAccessLUSeqNo = parseInt(window.gSession.Acc.Dashboard.LastAccessLUSeqNo)
                    console.log("GetLastAccessData objData:", objData)
                }
                intIndex++
            } // end of while 
        }

        return objData
    } // end of GetLastAccessData

    /*===========================================
    summary: 取得 LU 顯示名稱
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetLUDisplayName(BookDefObject, SectionSeqNo, SubSectionSeqNo, SubSubSectionSeqNo)
    {
        // console.log(COMP_NAME + ".GetLUDisplayName: ", BookDefObject, SectionSeqNo, SubSectionSeqNo, SubSubSectionSeqNo)

        let intSectionIndex = -1
        let intSubSectionIndex = -1
        let intSubSubSectionIndex = -1

        let intSIndex = 0
        let intSectionCount = BookDefObject.Section.length
        let intSSIndex = 0
        let intSubSectionCount = 0
        let intSSSIndex = 0
        let intSubSubSectionCount = 0
        let blnFound = false

        while ((!blnFound) && (intSIndex < intSectionCount))
        {
            if (BookDefObject.Section[intSIndex].SectionSeqNo === SectionSeqNo)
            {
                intSectionIndex = intSIndex

                intSSIndex = 0
                intSubSectionCount = BookDefObject.Section[intSIndex].SubSection.length
                while ((!blnFound) && (intSSIndex < intSubSectionCount))
                {
                    if (BookDefObject.Section[intSIndex].SubSection[intSSIndex].SubSectionSeqNo === SubSectionSeqNo)
                    {
                        intSubSectionIndex = intSSIndex

                        if (SubSubSectionSeqNo !== null)
                        {
                            intSSSIndex = 0
                            intSubSubSectionCount = BookDefObject.Section[intSIndex].SubSection[intSSIndex].SubSubSection.length
                            while ((!blnFound) && (intSSSIndex < intSubSubSectionCount))
                            {
                                if (BookDefObject.Section[intSIndex].SubSection[intSSIndex].SubSubSection[intSSSIndex].SubSubSectionSeqNo === SubSubSectionSeqNo)
                                {
                                    intSubSubSectionIndex = intSSSIndex
                                    blnFound = true
                                }
                                intSSSIndex++
                            }
                        }
                        else
                        {
                            blnFound = true
                        }
                    }
                    intSSIndex++
                }
            }
            intSIndex++
        }

        let objSection = null

        if (SubSubSectionSeqNo !== null)
        {
            objSection = BookDefObject.Section[intSectionIndex].SubSection[intSubSectionIndex].SubSubSection[intSubSubSectionIndex]
        }
        else
        {
            objSection = BookDefObject.Section[intSectionIndex].SubSection[intSubSectionIndex]
        }

        let strSectionName = ''
        if (
            (typeof (objSection) !== 'undefined') &&
            (objSection !== null)
            )
        {
            strSectionName = objSection.Name
        }
        return strSectionName
    } // end of GetLUDisplayName

    /*===========================================
    summary: 開啟 ClassManagement
    remarks: 000 Tim 2021/11/03 Create
             001 Tim 2023/06/14 CallApp前 清空 AppCallbackRef
             002 Tim 2023/07/06 支援 OPEN_SAFARI_VIEW
             003 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function OpenClassManagement()
    {
        let strInApp4QueryString = window.Globals.GetInAppQueryString4BCClass()

        let strWebSiteUrl = PackageVariablesLibs.SysConfig.ClassWebSiteUrl
        let strArgList = "Credential=" + window.gSession.Acc.Credential
        strArgList += strInApp4QueryString

        let strUrl = strWebSiteUrl + "?" + strArgList

        if (!window.gSession.App.InApp)
        {
            // In Web

            // 如果包在 iFrame, 會無法 Login      Tim20.12.02
            // 所以改直接另開頁面
            window.open(strUrl)
        } // end of if (!window.gSession.App.InApp)
        else
        {
            console.log(COMP_NAME + ".OpenClassManagement App.AppVersion: ", window.gSession.App.AppVersion)

            // In App
            let intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, window.gConst.OPEN_SAFARI_VIEW_APP_VER)
            let intAction = -1
            let strQueryString = ""

            if (intCheckResult === -1)
            {
                // App版號 v3.1.0 b1 以前
                intAction = window.gConst.ACTION_OPEN_BROWSER
                strQueryString = "Action=" + intAction
                strQueryString += "&Credential=" + window.gSession.Acc.Credential
                strQueryString += "&BackRoute="
                strQueryString += "&Url=" + encodeURIComponent(strUrl)

                console.log(COMP_NAME + ".OpenClassManagement CallApp OpenBrowser strQueryString: ", strQueryString)
            } // end of if (intCheckResult === -1)
            else
            {
                // App版號 v3.1.0 b2 之後
                intAction = window.gConst.ACTION_OPEN_SAFARI_VIEW
                strQueryString = "Action=" + intAction
                strQueryString += "&Credential=" + window.gSession.Acc.Credential
                strQueryString += "&Url=" + encodeURIComponent(strUrl)

                console.log(COMP_NAME + ".OpenClassManagement CallApp OpenSafariView strQueryString: ", strQueryString)
            } // end of else

            // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
            ClientGatewayInPackage.CallApp(strQueryString)
        } // end of else
    } // end of OpenClassManagement
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 上方 區域 Cls
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function GetSubContentTopCls()
    {
        let objCls = cssHome.divSubContentTop

        if (
            (mintAccountRole !== window.gConst.CLASS_ACCOUNT_ROLE_TEACHER) &&
            (mintAccountRole !== window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
            )
        {
            // Personal 個人帳號 無Class
            objCls = cssHome.divSubContentTop4Personal
        }

        return objCls
    } // end of GetSubContentTopCls

    /*===========================================
    summary: 取得 下方 區域 Cls
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function GetSubContentBottomCls()
    {
        let objCls = cssHome.divSubContentBottom

        if (
            (mintAccountRole !== window.gConst.CLASS_ACCOUNT_ROLE_TEACHER) &&
            (mintAccountRole !== window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
            )
        {
            // Personal 個人帳號 無Class
            objCls = cssHome.divSubContentBottom4Personal
        }

        return objCls
    } // end of GetSubContentBottomCls

    /*===========================================
    summary: 取得 Progress元件 Cls
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function GetProgressItemCls(ProgressDropdownIndex, ProgressIndex)
    {
        let objCls = cssHome.divProgressItem

        if (ProgressDropdownIndex === ProgressIndex)
        {
            objCls = cssHome.divProgressItemSelected
        }

        return objCls
    } // end of GetProgressItemCls

    /*===========================================
    summary: 取得 Volume按鈕 Cls
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function GetBtnVolumeCls(CurrVolume, Volume)
    {
        let objCls = cssHome.btnVolume

        switch (Volume)
        {
            case 0:
                objCls = cssHome.btnVolume01
                if (CurrVolume === Volume)
                {
                    objCls = cssHome.btnVolumeSelected01
                }
                break
            case 3:
                objCls = cssHome.btnVolume04
                if (CurrVolume === Volume)
                {
                    objCls = cssHome.btnVolumeSelected04
                }
                break
            default:
                if (CurrVolume === Volume)
                {
                    objCls = cssHome.btnVolumeSelected
                }
                break
        }


        return objCls
    } // end of GetBtnVolumeCls
    // #endregion Get ClassName

    // #region Web Service After Process
    /*===========================================
    summary: 驗證帳號Email 後續流程
    remarks: 000 Tim 2021/12/21 Create
    ===========================================*/
    function VerifyAccountEmailAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".VerifyAccountEmailAfterProcess")

        if (
            (typeof (window.gSession.Acc.Profile) !== 'undefined') &&
            (window.gSession.Acc.Profile !== null) &&
            (typeof (window.gSession.Acc.Profile.Email) !== 'undefined') &&
            (window.gSession.Acc.Profile.Email !== null)

            )
        {
            window.gSession.Acc.Profile.Email = window.gSession.App.VEData.EmailAddr
        }
        window.gSession.Acc.EmailVerified = window.gEmailVerifyEnum.Verified
        LocalStorageLibs.SetAccLSElement("EmailVerified", window.gSession.Acc.EmailVerified)

        window.gSession.App.VEData.UserKey = ""
        window.gSession.App.VEData.Code = ""
        window.gSession.App.VEData.EmailAddr = ""

        setIsShowEmailVerifiedSuccess(true)
    } // end of VerifyAccountEmailAfterProcess

    /*===========================================
    summary: 取得 使用者 授權 後續流程
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function GetAccountAuthorizedAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetAccountAuthorizedAfterProcess")

        // Session Variables
        window.gSession.Acc.AccountAuthorized = JSON.parse(JSON.stringify(ReturnData))

        // LS
        LocalStorageLibs.SetAccLSElement("Authorized", JSON.stringify(window.gSession.Acc.AccountAuthorized))

        LoginAfterProcess()
    } // end of GetAccountAuthorizedAfterProcess

    /*===========================================
    summary: 同意 使用者條款 後續流程
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function AccountAcceptTermsAfterProcess()
    {
        console.log(COMP_NAME + ".AccountAcceptTermsAfterProcess")

        mobjCallParam = null
        setIsShowTermsOfUseWindow(false)

        GetDataProcessBegin()
    } // end of AccountAcceptTermsAfterProcess

    /*===========================================
    summary: 同意 親子條款 後續流程
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function AccountAcceptParentLetterAfterProcess()
    {
        console.log(COMP_NAME + ".AccountAcceptParentLetterAfterProcess")

        mobjCallParam = null
        setIsShowPCLWindow(false)
        LoginAfterProcess()
    } // end of AccountAcceptParentLetterAfterProcess

    /*===========================================
    summary: 刪除資料後 的 流程
    remarks: 000 Tim 2021/11/02 Create
             001 Tim 2022/01/22 改用 findIndex 取代 While 實作
    ===========================================*/
    function DeleteNewAssignmentAfterProcess()
    {
        console.log(COMP_NAME + ".DeleteNewAssignmentAfterProcess")

        let intIndex = 0;

        // 找到原始列表的資料 刪除資料
        intIndex = marrAssignmentSource.findIndex(AssignmentData => (parseInt(AssignmentData.NewAssignmentID) === parseInt(mobjCallParam.NewAssignmentID)))
        if (
            (typeof (intIndex) !== 'undefined') &&
            (intIndex !== null) &&
            (parseInt(intIndex) >= 0)
            )
        {
            marrAssignmentSource.splice(intIndex, 1)
        }

        // 找到原始列表的資料 刪除資料
        intIndex = marrAssignment.findIndex(AssignmentData => (parseInt(AssignmentData.NewAssignmentID) === parseInt(mobjCallParam.NewAssignmentID)))
        if (
            (typeof (intIndex) !== 'undefined') &&
            (intIndex !== null) &&
            (parseInt(intIndex) >= 0)
            )
        {
            marrAssignment.splice(intIndex, 1)
        }

        mintDeleteAssignmentID = 0
        mobjCallParam = null

        // 初始化列表
        InitAssignmentList()
    } // end of DeleteNewAssignmentAfterProcess

    /*===========================================
    summary: 取得購買提醒清單 後續流程
    remarks: 000 Tim 2023/08/31 Create
    ===========================================*/
    function GetSubscriptionReminderAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetSubscriptionReminderAfterProcess: ")

        console.log(COMP_NAME + ".GetSubscriptionReminderAfterProcess ReturnData: ", ReturnData)
                    
        if (
            (typeof (ReturnData) !== 'undefined') &&
            (ReturnData !== null)
            )
        {
            window.gSession.Acc.SubscriptionReminder = ReturnData
        } // end of (ReturnData !== null)

        console.log(COMP_NAME + ".GetSubscriptionReminderAfterProcess Acc.SubscriptionReminder: ", window.gSession.Acc.SubscriptionReminder)

        mobjCallParam = null

        ExecuteDataProcess()
    } // end of GetSubscriptionReminderAfterProcess

    /*===========================================
    summary: 取得班級 指派考卷列表 只撈一位學生 的 流程
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetClassNewAssignmentListByAccAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetClassNewAssignmentListByAccAfterProcess")

        marrAssignment = ReturnData.AssignmentList

        InitAssignmentList()

        mobjCallParam = null

        ExecuteDataProcess()
    } // end of GetClassNewAssignmentListByAccAfterProcess

    /*===========================================
    summary: 取得班級 指派考卷列表後 的 流程
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetClassNewAssignmentListAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetClassNewAssignmentListAfterProcess")

        marrAssignment = ReturnData.AssignmentList

        InitAssignmentList()

        mobjCallParam = null

        ExecuteDataProcess()
    } // end of GetClassNewAssignmentListAfterProcess

    /*===========================================
    summary: 取得帳號 新 學生進度表後 的 流程
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetClassAccAssignmentStatus4StudentAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetClassAccAssignmentStatus4StudentAfterProcess")

        let intVolume = parseInt(window.gSession.App.BookSeqNo) - 1
        let strBookSeqNo = window.gSession.App.BookSeqNo.toString().PadLeft(2)

        if (
            (typeof (ReturnData) !== 'undefined') &&
            (ReturnData !== null)
            )
        {
            marrStorage[intVolume] = ReturnData

            console.log(COMP_NAME + ".GetClassAccAssignmentStatus4StudentAfterProcess marrStorage: ", marrStorage)
        } // end of (ReturnData !== null)

        InitStudentReportData(window.gSession.App.BookDef[strBookSeqNo].Lesson, marrStorage[intVolume])

        mobjCallParam = null

        ExecuteDataProcess()
    } // end of GetClassAccAssignmentStatus4StudentAfterProcess

    /*===========================================
    summary: 取得 班級進度 資料後 的 流程
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetClassAccAssignmentStatus4TeacherAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetClassAccAssignmentStatus4TeacherAfterProcess")

        let intVolume = parseInt(window.gSession.App.BookSeqNo) - 1
        let strBookSeqNo = window.gSession.App.BookSeqNo.toString().PadLeft(2)
        if (
            (typeof (ReturnData) !== 'undefined') &&
            (ReturnData !== null)
            )
        {
            marrStorage[intVolume] = ReturnData

            console.log(COMP_NAME + ".GetClassAccAssignmentStatus4TeacherAfterProcess mobjStorage:", marrStorage)
        } // end of if (ReturnData !== null)

        InitReportData(window.gSession.App.BookDef[strBookSeqNo].Lesson, marrStorage[intVolume])

        mobjCallParam = null

        ExecuteDataProcess()
    } // end of GetClassAccAssignmentStatus4TeacherAfterProcess

    /*===========================================
    summary: 取得 帳號 進度表 資料後 的 流程
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetAccountDashboardAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetAccountDashboardAfterProcess: ", ReturnData)

        window.gSession.Acc.Dashboard = JSON.parse(JSON.stringify(ReturnData))
        window.gSession.Acc.Dashboard.ThisCheckTime = new Date()

        mobjDashboardDisplay = GetLastAccessData()

        setDashboardCheckTime(window.gSession.Acc.Dashboard.ThisCheckTime.getTime())

        console.log("window.gSession.Acc.Dashboard: ", window.gSession.Acc.Dashboard)

        if (
            (typeof (window.gSession.Acc.Dashboard) !== 'undefined') &&
            (window.gSession.Acc.Dashboard !== null) &&
            (typeof (window.gSession.Acc.Dashboard.LastAccessBookSeqNo) !== 'undefined') &&
            (parseInt(window.gSession.Acc.Dashboard.LastAccessBookSeqNo) > 0)
            )
        {
            window.gSession.App.BookSeqNo = parseInt(window.gSession.Acc.Dashboard.LastAccessBookSeqNo)

            setBookSeqNo(window.gSession.App.BookSeqNo)
        }

        mobjCallParam = null

        ExecuteDataProcess()
    } // end of GetAccountDashboardAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 取得帳號 進度表
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetAccountDashboard()
    {
        console.log(COMP_NAME + ".GetAccountDashboard")

        let objRetryFuncRef = GetAccountDashboard
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetAccountDashboardCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetAccountDashboard);

            let objCallData = {
                "Func": "GetAccountDashboard",
                "LastCheckTime": mobjCallParam.LastCheckTime,
                "BookCategoryID": mobjCallParam.BookCategoryID
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetAccountDashboard

    /*===========================================
    summary: 取得帳號 進度表 Callback
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetAccountDashboardCallback(Return)
    {
        console.log(COMP_NAME + ".GetAccountDashboardCallback")

        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetGradeList_No;
        let strErrorTitle = window.gAppUI.ERR_GetGradeList_Title;
        let strErrMsg = window.gAppUI.ERR_GetGradeList_Msg;
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break;
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break;
            }

            console.log("GetAccountDashboardCallback: ErrNo: ", Return.ErrNo);
            console.log("GetAccountDashboardCallback: CalledErrNo: ", Return.CalledErrNo);
        }
        else
        {
            console.log("GetAccountDashboardCallback Return.Data: ", Return.Data);

            GetAccountDashboardAfterProcess(Return.Data)
        }
    } // end of GetAccountDashboardCallback

    /*===========================================
    summary: 取得帳號 新 班級進度表 For 老師
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetClassAccAssignmentStatus4Teacher()
    {
        console.log(COMP_NAME + ".GetClassAccAssignmentStatus4Teacher")

        let objRetryFuncRef = GetClassAccAssignmentStatus4Teacher
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetClassAccAssignmentStatus4TeacherCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetClassAccAssignmentStatus4Teacher)

            let objCallData = {
                "Func": "GetClassAccAssignmentStatus4Teacher",
                "ClassID": mobjCallParam.ClassID,
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "BookSeqNo": mobjCallParam.BookSeqNo
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetClassAccAssignmentStatus4Teacher

    /*===========================================
    summary: 取得帳號 新進度表 For 老師 Callback
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetClassAccAssignmentStatus4TeacherCallback(Return, InstructionInfo)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetClassAccAssignmentStatus4Teacher_No
        let strErrorTitle = window.gAppUI.ERR_GetClassAccAssignmentStatus4Teacher_Title
        let strErrMsg = window.gAppUI.ERR_GetClassAccAssignmentStatus4Teacher_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break;
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetClassAccAssignmentStatus4TeacherCallback: ErrNo: ", Return.ErrNo)
            console.log("GetClassAccAssignmentStatus4TeacherCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetClassAccAssignmentStatus4TeacherCallback Return.Data: ", Return.Data)

            GetClassAccAssignmentStatus4TeacherAfterProcess(Return.Data)
        }
    } // end of GetClassAccAssignmentStatus4TeacherCallback

    /*===========================================
    summary: 取得帳號 新 學生進度表
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetClassAccAssignmentStatus4Student()
    {
        console.log(COMP_NAME + ".GetClassAccAssignmentStatus4Student")

        let objRetryFuncRef = GetClassAccAssignmentStatus4Student
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetClassAccAssignmentStatus4StudentCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetClassAccAssignmentStatus4Student)

            let objCallData = {
                "Func": "GetClassAccAssignmentStatus4Student",
                "Assignee": mobjCallParam.Assignee,
                "ClassID": mobjCallParam.ClassID,
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "BookSeqNo": mobjCallParam.BookSeqNo
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetClassAccAssignmentStatus4Student

    /*===========================================
    summary: 取得帳號 新 學生進度表 Callback
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetClassAccAssignmentStatus4StudentCallback(Return, InstructionInfo)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetClassAccAssignmentStatus4Student_No
        let strErrorTitle = window.gAppUI.ERR_GetClassAccAssignmentStatus4Student_Title
        let strErrMsg = window.gAppUI.ERR_GetClassAccAssignmentStatus4Student_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break;
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetClassAccAssignmentStatus4StudentCallback: ErrNo: ", Return.ErrNo)
            console.log("GetClassAccAssignmentStatus4StudentCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetClassAccAssignmentStatus4StudentCallback Return.Data: ", Return.Data)

            GetClassAccAssignmentStatus4StudentAfterProcess(Return.Data)
        }
    } // end of GetClassAccAssignmentStatus4StudentCallback

    /*===========================================
    summary: 取得班級 指派考卷列表
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetClassNewAssignmentList()
    {
        let objRetryFuncRef = GetClassNewAssignmentList
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetClassNewAssignmentListCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetAssignmentData)

            let objCallData = {
                "Func": "GetClassNewAssignmentList",
                "ClassID": mobjCallParam.ClassID,
                "BookCategoryID": mobjCallParam.BookCategoryID     // 增加 BookCategoryID，支援新版    Tim16.03.09
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetClassNewAssignmentList

    /*===========================================
    summary: 取得班級 指派考卷列表 Callback
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetClassNewAssignmentListCallback(Return, InstructionInfo)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetTeacherClassAssignment_No;
        let strErrorTitle = window.gAppUI.ERR_GetTeacherClassAssignment_Title;
        let strErrMsg = window.gAppUI.ERR_GetTeacherClassAssignment_Msg;
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break;
            }

            console.log("GetClassNewAssignmentListCallback: ErrNo: ", Return.ErrNo)
            console.log("GetClassNewAssignmentListCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetClassNewAssignmentListCallback Return.Data: ", Return.Data)

            GetClassNewAssignmentListAfterProcess(Return.Data)
        }
    } // end of GetClassNewAssignmentListCallback

    /*===========================================
    summary: 取得班級 指派考卷列表 只撈一位學生
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetClassNewAssignmentListByAcc()
    {
        let objRetryFuncRef = GetClassNewAssignmentListByAcc
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetClassNewAssignmentListByAccCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetAssignmentData)

            let objCallData = {
                "Func": "GetClassNewAssignmentListByAcc",
                "ClassID": mobjCallParam.ClassID,
                "BookCategoryID": mobjCallParam.BookCategoryID,     // 增加 BookCategoryID，支援新版    Tim16.03.09
                "StudentAccID": mobjCallParam.StudentAccID
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetClassNewAssignmentListByAcc

    /*===========================================
    summary: 取得班級 指派考卷列表 Callback
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetClassNewAssignmentListByAccCallback(Return, InstructionInfo)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetTeacherClassAssignment_No
        let strErrorTitle = window.gAppUI.ERR_GetTeacherClassAssignment_Title
        let strErrMsg = window.gAppUI.ERR_GetTeacherClassAssignment_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetClassNewAssignmentListByAccCallback: ErrNo: ", Return.ErrNo)
            console.log("GetClassNewAssignmentListByAccCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetClassNewAssignmentListByAccCallback Return.Data: ", Return.Data)

            GetClassNewAssignmentListByAccAfterProcess(Return.Data)
        }
    } // end of GetClassNewAssignmentListByAccCallback

    /*===========================================
    summary: 取得購買提醒清單
    remarks: 000 Tim 2023/08/31 Create
    ===========================================*/
    function GetSubscriptionReminder()
    {
        let objRetryFuncRef = GetSubscriptionReminder

        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        } // end of if (!window.navigator.onLine)
        else
        {
            let objCallbackFuncRef = GetSubscriptionReminderCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetSubscriptionReminder)

            let objCallData = {
                "Func": "GetSubscriptionReminder"
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        } // end of else
    } // end of GetSubscriptionReminder

    /*===========================================
    summary: 取得購買提醒清單 Callback
    remarks: 000 Tim 2023/08/31 Create
    ===========================================*/
    function GetSubscriptionReminderCallback(Return)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetSubscriptionReminder_No
        let strErrorTitle = window.gAppUI.ERR_GetSubscriptionReminder_Title
        let strErrMsg = window.gAppUI.ERR_GetSubscriptionReminder_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            } // end of switch (Return.CalledErrNo)

            console.log("GetSubscriptionReminderCallback ErrNo: ", Return.ErrNo)
            console.log("GetSubscriptionReminderCallback CalledErrNo: ", Return.CalledErrNo)
        } // end of if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        else
        {
            console.log("GetSubscriptionReminderCallback Return.Data: ", Return.Data)

            GetSubscriptionReminderAfterProcess(Return.Data)
        } // end of else
    } // end of GetSubscriptionReminderCallback

    /*===========================================
    summary: 點擊Delete 呼叫後端 刪除資料
    remarks: 000 Tim 2020/11/17 Create
    ===========================================*/
    function DeleteNewAssignment()
    {
        let objRetryFuncRef = DeleteNewAssignment
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = DeleteNewAssignmentCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_DeleteAssignment);

            let objCallData = {
                "Func": "DeleteNewAssignment",
                "NewAssignmentID": mobjCallParam.NewAssignmentID
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of DeleteNewAssignment

    /*===========================================
    summary: 點擊Delete 呼叫後端 刪除資料 Callback
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function DeleteNewAssignmentCallback(Return, InstructionInfo)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_DeleteClassAssignment_No
        let strErrorTitle = window.gAppUI.ERR_DeleteClassAssignment_Title
        let strErrMsg = window.gAppUI.ERR_DeleteClassAssignment_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("DeleteNewAssignmentCallback: ErrNo: ", Return.ErrNo)
            console.log("DeleteNewAssignmentCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("DeleteNewAssignmentCallback Return.Data: ", Return.Data)

            DeleteNewAssignmentAfterProcess()
        }
    } // end of DeleteNewAssignmentCallback

    /*===========================================
    summary: 同意 親子條款
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function AccountAcceptParentLetter()
    {
        let objRetryFuncRef = AccountAcceptParentLetter
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = AccountAcceptParentLetterCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_AccountAcceptPCL)

            let objCallData = {
                "Func": "AccountAcceptParentLetter",
                "ParentLetterVersion": mobjCallParam.ParentLetterVersion
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of AccountAcceptParentLetter

    /*===========================================
    summary: 同意 親子條款 Callback
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function AccountAcceptParentLetterCallback(Return, InstructionInfo)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_AccountAcceptPCL_No
        let strErrorTitle = window.gAppUI.ERR_AccountAcceptPCL_Title
        let strErrMsg = window.gAppUI.ERR_AccountAcceptPCL_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("AccountAcceptParentLetterCallback: ErrNo: ", Return.ErrNo)
            console.log("AccountAcceptParentLetterCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("AccountAcceptParentLetterCallback Return.Data: ", Return.Data)

            AccountAcceptParentLetterAfterProcess()
        }
    } // end of AccountAcceptParentLetterCallback

    /*===========================================
    summary: 同意 使用者條款
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function AccountAcceptTerms()
    {
        let objRetryFuncRef = AccountAcceptTerms
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = AccountAcceptTermsCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_AccountAcceptTerms)

            let objCallData = {
                "Func": "AccountAcceptTerms",
                "TermsVersion": mobjCallParam.TermsVersion
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of AccountAcceptTerms

    /*===========================================
    summary: 同意 使用者條款 Callback
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function AccountAcceptTermsCallback(Return, InstructionInfo)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_AccountAcceptTerms_No
        let strErrorTitle = window.gAppUI.ERR_AccountAcceptTerms_Title
        let strErrMsg = window.gAppUI.ERR_AccountAcceptTerms_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("AccountAcceptTermsCallback: ErrNo: ", Return.ErrNo)
            console.log("AccountAcceptTermsCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("AccountAcceptTermsCallback Return.Data: ", Return.Data)

            AccountAcceptTermsAfterProcess()
        }
    } // end of AccountAcceptTermsCallback

    /*===========================================
    summary: 取得 使用者 授權
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function GetAccountAuthorized()
    {
        let objRetryFuncRef = GetAccountAuthorized
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetAccountAuthorizedCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetAccountAuthorized)

            let objCallData = {
                "Func": "GetAccountAuthorized",
                "BundleID": mobjCallParam.BundleID,
                "AppVersion": mobjCallParam.AppVersion,
                "BookCategoryID": mobjCallParam.BookCategoryID
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetAccountAuthorized

    /*===========================================
    summary: 取得 使用者 授權 Callback
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function GetAccountAuthorizedCallback(Return, InstructionInfo)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetAccountAuthorized_No
        let strErrorTitle = window.gAppUI.ERR_GetAccountAuthorized_Title
        let strErrMsg = window.gAppUI.ERR_GetAccountAuthorized_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetAccountAuthorizedCallback: ErrNo: ", Return.ErrNo)
            console.log("GetAccountAuthorizedCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetAccountAuthorizedCallback Return.Data: ", Return.Data)

            GetAccountAuthorizedAfterProcess(Return.Data)
        }
    } // end of GetAccountAuthorizedCallback

    /*===========================================
    summary: 驗證帳號Email
    remarks: 000 Tim 2021/12/21 Create
    ===========================================*/
    function VerifyAccountEmail()
    {
        let objRetryFuncRef = VerifyAccountEmail
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = VerifyAccountEmailCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_VerifyAccountEmail)

            let objCallData = {
                "Func": "VerifyAccountEmail",
                "AccountID": mobjCallParam.AccountID,
                "Code": mobjCallParam.Code,
                "EmailAddr": mobjCallParam.EmailAddr
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of VerifyAccountEmail

    /*===========================================
    summary: 驗證帳號Email Callback
    remarks: 000 Tim 2021/12/21 Create
    ===========================================*/
    function VerifyAccountEmailCallback(Return, InstructionInfo)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_VerifyAccountEmail_No
        let strErrorTitle = window.gAppUI.ERR_VerifyAccountEmail_Title
        let strErrMsg = window.gAppUI.ERR_VerifyAccountEmail_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                case window.gConfig.WEB_GATEWAY_RETURN_ERR_UNKNOWN_FUNCTION:
                    strErrMsg = window.gAppUI.ERR_UnknownFunction_Msg
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo)
                    break
                case window.gConst.WEB_GATEWAY_RETURN_ERR_VE_EXIST_EMAIL_WITH_OTHER_ACCOUNTID: // -140186,  // 你輸入的信箱已存在 158
                    strErrMsg = window.gAppUI.ERR_VEExistEmailWithOtherAccountID_Msg
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
                case window.gConst.WEB_GATEWAY_RETURN_ERR_VE_NOT_YET_CLICK_VERIFY_LINK: // -140171,  // 再次寄送認證信到你的信箱 153
                    strErrMsg = window.gAppUI.ERR_VENotYetClickVerifyLink_Msg
                    GlobalLibs.OkErrorHandler(strErrorTitle, strErrMsg)
                    break
                case window.gConst.WEB_GATEWAY_RETURN_ERR_VE_ALREADY_VERIFIED: // -140172,  // 此連結已驗證過 154
                    strErrMsg = window.gAppUI.ERR_VEAlreadyVerified_Msg
                    GlobalLibs.OkErrorHandler(strErrorTitle, strErrMsg)
                    break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("VerifyAccountEmailCallback: ErrNo: ", Return.ErrNo)
            console.log("VerifyAccountEmailCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("VerifyAccountEmailCallback Return.Data: ", Return.Data)

            VerifyAccountEmailAfterProcess(Return.Data)
        }
    } // end of VerifyAccountEmailCallback
    // #endregion Web Service

    // #region Render元件
    /*===========================================
    summary: Volume Button 顯示Component
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentVolumeButton({ CurrVolume, Volume })
    {
        return (
            <div className={GetBtnVolumeCls(CurrVolume, Volume)} onClick={() => VolumeOnTapHandler(Volume)}>
                {window.gSession.App.BookCategoryDef.Book[Volume].Name}
            </div>
        )
    } // end of ComponentVolumeButton

    /*===========================================
    summary: Progress Title 4 StudentView 顯示Component
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentProgressTitle4StudentView()
    {
        let objBlock = null
        if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            objBlock = <>
                <div className={cssHome.btnProgressBack} onClick={() => ProgressBackOnTapHandler()} />
                <div className={cssHome.divProgressTitle4Back}>
                    {window.gAppUI.LBL_Progress}
                </div>
            </>
        }
        else
        {
            objBlock = <div className={cssHome.divProgressTitle}>
                {window.gAppUI.LBL_Progress}
            </div>
        }

        return objBlock
    } // end of ComponentProgressTitle4StudentView

    /*===========================================
    summary: Progress LessonListText 顯示Component
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentLessonListText({ StateProgressViewMode, StateBookSeqNo })
    {
        let strLessonListText = ""

        if (StateProgressViewMode === ProgressViewModeEnum.OverView)
        {
            strLessonListText = window.gAppUI.LBL_OverView
        }
        else if (StateProgressViewMode === ProgressViewModeEnum.LessonView)
        {
            let strBookSeqNo = StateBookSeqNo.toString().PadLeft(2)
            strLessonListText = window.gSession.App.BookDef[strBookSeqNo].Lesson[mobjProgressViewData.LessonIndex].PrefixName
        }

        return (
            <>
                <div className={cssHome.divLessonListText}>
                    {strLessonListText}
                </div>
                <div className={cssHome.divDropdownTriangle} />
            </>
        )
    } // end of ComponentLessonListText

    /*===========================================
    summary: Progress Title 4 OverView 顯示Component
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentProgressTitle4OverView({ StateProgressViewMode })
    {
        let objBlock = null
        if (StateProgressViewMode === ProgressViewModeEnum.OverView)
        {
            objBlock =  <div className={cssHome.divProgressTitle}>
                            {window.gAppUI.LBL_Progress}
                        </div>
        }
        else if (StateProgressViewMode === ProgressViewModeEnum.LessonView)
        {
            objBlock =  <>
                            <div className={cssHome.btnProgressBack} onClick={() => ProgressBackOnTapHandler()} />
                            <div className={cssHome.divProgressTitle4Back}>
                                {window.gAppUI.LBL_Progress}
                            </div>
                        </>
        }

        return objBlock
    } // end of ComponentProgressTitle4OverView

    /*===========================================
    summary: Last Access 4 NA 顯示Component
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function ComponentLastAccess({ LastAccessData })
    {
        return (
            <div className={cssHome.divLastAccessMain} onClick={() => LastAccessOnTapHandler(LastAccessData.LastAccessLessonID, LastAccessData.LastAccessLessonIndex, LastAccessData.LastAccessLUSeqNo)} >
                <div className={cssHome.divLastTitle}>
                    {window.gAppUI.LBL_LastAccess}
                </div>
                <div className={cssHome.divLastAccessContentMain}>
                    <div />
                    <div className={cssHome.divLastAccessContent}>
                        <div className={cssHome.divLessonPrefixName}>
                            {LastAccessData.PrefixName}
                        </div>
                        <div className={cssHome.divLastAccessMsg}>
                            {LastAccessData.LastAccessText}
                        </div>
                    </div>
                    <div />
                </div>
            </div>
        )
    } // end of ComponentLastAccess

    /*===========================================
    summary: Last Access 4 NA 顯示Component
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function ComponentLastAccess4NA({ PrefixName })
    {
        return (
            <div className={cssHome.divLastAccessMain}>
                <div className={cssHome.divLastTitle}>
                    {window.gAppUI.LBL_LastAccess}
                </div>
                <div className={cssHome.divLastAccessContentNA}>
                    <div className={cssHome.divLessonPrefixName}>
                        {PrefixName}
                    </div>
                </div>
            </div>
        )
    } // end of ComponentLastAccess4NA

    /*===========================================
    summary: Bulletin Miscellaneous 4 Message 顯示Component
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function ComponentBulletinMiscellaneous4Message({ Assignment })
    {
        // 開始時間         // Server讀出來的時間 轉 顯示時間
        let datStart = new Date(Assignment.StartDate.replace(/-/g, '/'))
        datStart.setMinutes(datStart.getMinutes() + window.gSession.App.MinutesOffset)
        let strStart = datStart.FormateBCDisplayDateTime().split(" ")[0].replace(/-/g, '/')

        return (
            <div className={cssHome.divDateMain4Msg}>
                <div className={cssHome.divDateIcon} />
                <div className={cssHome.divDateText}>
                    {strStart}
                </div>
            </div>
        )
    } // end of ComponentBulletinMiscellaneous4Message

    /*===========================================
    summary: Bulletin Miscellaneous 4 Assignment 顯示Component
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function ComponentBulletinMiscellaneous4Assignment({ Assignment, AssignmentIndex, DueDate })
    {
        let objPracticeLU = GetPracticeLU(parseInt(Assignment.LUCatSeqNo))
        // console.log(COMP_NAME + ".RenderBulletinMiscellaneousWrapper objPracticeLU: ", objPracticeLU)

        let intLessonID = parseInt(Assignment.LessonID) % 100
        let strTitle = window.gAppUI.LBL_Lesson + ' ' + intLessonID
        // 橫式 Landscape
        strTitle += ' - ' + objPracticeLU.DisplayName

        // 截止時間         // Server讀出來的時間 轉 顯示時間
        let strDue = DueDate.FormateBCDisplayDateTime().split(" ")[0].replace(/-/g, '/')
        strDue = window.gAppUI.LBL_Due + ' ' + strDue
        // console.log("strDue: ", strDue)

        return (
            <div className={cssHome.divBulletinMiscellaneous4Lesson} onClick={() => BulletinLessonOnTapHandler(AssignmentIndex)}>
                <div className={cssHome.btnLesson}>
                    <div className={cssHome.divLessonIcon} />
                    <div className={cssHome.divLessonText}>
                        {strTitle}
                    </div>
                </div>

                <div className={cssHome.divDateMain}>
                    <div className={cssHome.divDateIcon} />
                    <div className={cssHome.divDateText}>
                        {strDue}
                    </div>
                </div>
            </div>
        )
    } // end of ComponentBulletinMiscellaneous4Assignment

    /*===========================================
    summary: Bulletin Row 4 Personal 顯示Component
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function ComponentBulletinRow4Personal({ Assignment, AssignmentIndex })
    {
        return (
            <>
                <div className={cssHome.btnBulletinRowButtonMain} onClick={() => BulletinViewOnTapHandler(AssignmentIndex)}>
                    <div className={cssHome.btnBulletinView} />
                </div>

                <div className={cssHome.btnBulletinMessage4Student} onClick={() => BulletinMessageOnTapHandler(AssignmentIndex)}>
                    {Assignment.Message}
                </div>
            </>
        )
    } // end of ComponentBulletinRow4Personal

    /*===========================================
    summary: Bulletin Row 4 Teacher 顯示Component
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function ComponentBulletinRow4Student({ Assignment, AssignmentIndex, NowDate, DueDate })
    {
        let blnIsNotify = false
        let objNotifyBlock = null

        if (
            (DueDate != null) &&
            (DueDate.valueOf() < NowDate.valueOf())
            )
        {
            blnIsNotify = false
        }
        else if (typeof (Assignment.TestedTime) === 'undefined')
        {
            blnIsNotify = false
        }
        else if (
            (Assignment.TestedTime === null) ||
            (Assignment.TestedTime === "")
            )
        {
            blnIsNotify = true
        }
        else
        {
            blnIsNotify = false
        }

        if (blnIsNotify)
        {
            objNotifyBlock = <div className={cssHome.divBulletinNotify4Edit} />
        }

        return (
            <>
                <div className={cssHome.btnBulletinRowButtonMain} onClick={() => BulletinViewOnTapHandler(AssignmentIndex)}>
                    <div className={cssHome.btnBulletinView} />
                    {objNotifyBlock}
                </div>

                <div className={cssHome.btnBulletinMessage4Student} onClick={() => BulletinMessageOnTapHandler(AssignmentIndex)}>
                    {Assignment.Message}
                </div>
            </>
        )
    } // end of ComponentBulletinRow4Student

    /*===========================================
    summary: Bulletin Row 4 Teacher 顯示Component
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function ComponentBulletinRow4Teacher({ Assignment, AssignmentIndex, NowDate, DueDate })
    {
        let blnIsNotify = false
        let objNotifyBlock = null

        if (
            (DueDate !== null) &&
            (DueDate.valueOf() < NowDate.valueOf())
            )
        {
            blnIsNotify = false
        }
        else if (parseInt(Assignment.CompleteNum) === parseInt(Assignment.TotalNum))
        {
            blnIsNotify = false
        }
        else
        {
            blnIsNotify = true
        }

        if (blnIsNotify)
        {
            objNotifyBlock = <div className={cssHome.divBulletinNotify4Edit} />
        }

        return (
            <>
                <div className={cssHome.btnBulletinRowButtonMain} onClick={() => BulletinEditOnTapHandler(AssignmentIndex)} >
                    <div className={cssHome.btnBulletinEdit} />
                    {objNotifyBlock}
                </div>
                <div className={cssHome.btnBulletinDelete} onClick={() => BulletinDeleteOnTapHandler(AssignmentIndex)} />

                <div className={cssHome.btnBulletinMessage} onClick={() => BulletinMessageOnTapHandler(AssignmentIndex)}>
                    {Assignment.Message}
                </div>
            </>
        )
    } // end of ComponentBulletinRow4Teacher

    /*===========================================
    summary: Bulletin AddButton 顯示Component
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function ComponentBulletinAddButton({ AccountRole })
    {
        if (AccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            return (
                <div className={cssHome.btnBulletinAdd} onClick={() => BulletinAddOnTapHandler()} />
            )
        }
        else
        {
            return ""
        }

    } // end of ComponentBulletinAddButton

    /*===========================================
    summary: BulletinTitle 顯示Component
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function ComponentBulletinTitle()
    {
        return (
            <div className={cssHome.divBulletinTitle}>
                {window.gAppUI.LBL_Bulletin}
            </div>
        )
    } // end of ComponentBulletinTitle
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render Email驗證成功視窗 的顯示
    remarks: 000 Tim 2021/12/21 Create
    ===========================================*/
    function RenderEmailVerifiedSuccessWrapper(StateIsShowEmailVerifiedSuccess)
    {
        if (StateIsShowEmailVerifiedSuccess)
        {
            return (
                <EmailVerifiedSuccess CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderEmailVerifiedSuccessWrapper

    /*===========================================
    summary: Render Email驗證 提示視窗 的顯示
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function RenderEmailVerifiedWrapper(StateIsShowEmailVerified)
    {
        if (StateIsShowEmailVerified)
        {
            return (
                <EmailVerified CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderEmailVerifiedWrapper

    /*===========================================
    summary: Render 購買提示視窗 的顯示
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function RenderSubscriptionReminderWrapper(StateIsShowSubscriptionReminder)
    {
        if (StateIsShowSubscriptionReminder)
        {
            return (
                <SubscriptionReminder ExpirationDate={mobjShowComponentParam.ExpirationDate}
                    ExpiredStatus={mobjShowComponentParam.ExpiredStatus}
                    IsTrial={mobjShowComponentParam.IsTrial}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderSubscriptionReminderWrapper

    // remarks: 001 Tim 2023/09/07 開啟DCPAssessmentUrl App
    //                             不使用 之前 會開下載視窗的流程，改用 開其他App的新流程
    // function RenderDownloadAnotherAppWindowWrapper()
    // {
    //     let objBlock = null
    //     if (showDownloadAnotherAppWindow)
    //     {
    //         objBlock = <DownloadAnotherAppWindow CallbackRef={DownloadAnotherAppWindowCallback} />
    //     }
    //     return objBlock
    // }

    /*===========================================
    summary: Render 指派LU列表視窗 單元為單位 的顯示
    remarks: 000 Tim 2021/12/27 Create
    ===========================================*/
    function RenderAssignmentPracticeSheetWrapper(StateIsShowAssignmentPracticeSheet)
    {
        if (StateIsShowAssignmentPracticeSheet)
        {
            // "Arguments": {
            //     "LessonID": CallbackObj.LessonID,
            //     "LUCatSeqNo": CallbackObj.LUCatSeqNo,
            //     "Assignee": CallbackObj.Assignee
            // }
            return (
                <AssignmentPracticeSheet Arguments={mobjShowComponentParam.Arguments}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderAssignmentPracticeSheetWrapper

    /*===========================================
    summary: Render 指派LU列表視窗 的顯示
    remarks: 000 Tim 2021/12/27 Create
    ===========================================*/
    function RenderAssignReportWrapper(StateIsShowAssignReport)
    {
        if (StateIsShowAssignReport)
        {
            // "Arguments": {
            //     "AssignmentSource": marrAssignmentSource[AssignmentIndex]
            // }
            return (
                <AssignReport Arguments={mobjShowComponentParam.Arguments}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderAssignReportWrapper

    /*===========================================
    summary: Render 編輯指派LU視窗 的顯示
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function RenderAssignEditWrapper(StateIsShowAssignEdit)
    {
        if (StateIsShowAssignEdit)
        {
            // "Arguments": {
            //     "AssignmentSource": marrAssignmentSource[AssignmentIndex]
            // }
            return (
                <AssignEdit Arguments={mobjShowComponentParam.Arguments}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderAssignEditWrapper

    /*===========================================
    summary: Render 指派LU視窗 的顯示
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function RenderLUAssignWrapper(StateIsShowLUAssign)
    {
        if (StateIsShowLUAssign)
        {
            return (
                <LUAssign CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderLUAssignWrapper

    /*===========================================
    summary: Render BCAppsWindows 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderBCAppsWindowsWrapper(StateIsShowBCAppsWindows)
    {
        if (StateIsShowBCAppsWindows)
        {
            return (
                <BCAppsWindows CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderBCAppsWindowsWrapper

    /*===========================================
    summary: Render OpenWebWindow 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderOpenWebWindowWrapper(StateIsShowOpenWebWindow)
    {
        if (StateIsShowOpenWebWindow)
        {
            return (
                <OpenWebWindow WebSiteUrl={mobjShowComponentParam.WebSiteUrl}
                    ArgList={mobjShowComponentParam.ArgList}
                    IsAssessments={mobjShowComponentParam.IsAssessments}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderOpenWebWindowWrapper

    /*===========================================
    summary: Render BulletinMsgBox 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderBulletinMsgBoxWrapper(StateIsShowBulletinMsgBox)
    {
        if (StateIsShowBulletinMsgBox)
        {
            return (
                <BulletinMsgBox Message={mobjShowComponentParam.Message}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderBulletinMsgBoxWrapper

    /*===========================================
    summary: Render 親子條款視窗 的顯示
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function RenderTermsOfUseWindowWrapper(StateIsShowTermsOfUseWindow)
    {
        if (StateIsShowTermsOfUseWindow)
        {
            return (
                <TermsOfUseWindow TermsUrl={window.gSession.Acc.TermsData.Url}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderTermsOfUseWindowWrapper

    /*===========================================
    summary: Render 親子條款視窗 的顯示
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function RenderPCLWindowWrapper(StateIsShowPCLWindow)
    {
        if (StateIsShowPCLWindow)
        {
            return (
                <PCLWindow CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderPCLWindowWrapper

    /*===========================================
    summary: Render ProgressMemoArea 的顯示
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function RenderProgressMemoAreaWrapper(StateReportTime)
    {
        if (StateReportTime > 0)
        {
            return (
                <div className={cssHome.divProgressMemoArea}>
                    <div className={cssHome.divMemoIcon4NotSubmitted} />
                    <div className={cssHome.divMemoText}>
                        {window.gAppUI.LBL_NotSubmitted_EN}
                    </div>

                    <div className={cssHome.divMemoIcon4GradePending} />
                    <div className={cssHome.divMemoText}>
                        {window.gAppUI.LBL_GradePending_EN}
                    </div>

                    <div className={cssHome.divMemoIcon4NeedHelp} />
                    <div className={cssHome.divMemoText}>
                        {window.gAppUI.LBL_NeedHelp_EN}
                    </div>

                    <div className={cssHome.divMemoIcon4Completed} />
                    <div className={cssHome.divMemoText}>
                        {window.gAppUI.LBL_Completed_EN}
                    </div>
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderProgressMemoAreaWrapper

    /*===========================================
    summary: Render ProgressView 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderProgressViewWrapper(StateProgressViewMode, StateBookSeqNo)
    {
        let objBlock = ""

        if (StateProgressViewMode === ProgressViewModeEnum.OverView)
        {
            let intLessonID = 0
            if (
                (typeof (window.gSession.Acc.Dashboard) !== 'undefined') &&
                (window.gSession.Acc.Dashboard !== null) &&
                (typeof (window.gSession.Acc.Dashboard.LastAccessLessonID) !== 'undefined') &&
                (window.gSession.Acc.Dashboard.LastAccessLessonID !== null)
                )
            {
                intLessonID = window.gSession.Acc.Dashboard.LastAccessLessonID
            }

            objBlock = <ProgressOverView BookSeqNo={StateBookSeqNo}
                            CurrLessonID={intLessonID}
                            ReportDataList={marrReportData}
                            CallbackRef={ComponentCallback} />
        }
        else if (StateProgressViewMode === ProgressViewModeEnum.LessonView)
        {
            objBlock = <ProgressLessonView
                            Arguments={mobjProgressLessonViewArguments}
                            CallbackRef={ComponentCallback} />
        }
        else if (StateProgressViewMode === ProgressViewModeEnum.StudentView)
        {
            objBlock = <ProgressStudentView
                            Arguments={mobjProgressStudentViewArguments}
                            CallbackRef={ComponentCallback} 
                            History={props.history} />
        }

        return objBlock
    } // end of RenderProgressViewWrapper

    /*===========================================
    summary: Render BulletinMsgBox 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderVolumeMainWrapper(StateBookSeqNo)
    {
        let intVolume = parseInt(StateBookSeqNo) - 1

        return (
            <div className={cssHome.divVolumeMain}>
                <ComponentVolumeButton CurrVolume={intVolume} Volume={0} />
                <ComponentVolumeButton CurrVolume={intVolume} Volume={1} />
                <ComponentVolumeButton CurrVolume={intVolume} Volume={2} />
                <ComponentVolumeButton CurrVolume={intVolume} Volume={3} />
            </div>
        )
    } // end of RenderVolumeMainWrapper

    /*===========================================
    summary: Render Progress Title 4 StudentView 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderProgressTitleMain4StudentViewWrapper()
    {
        let strDisplayName = ""
        if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            strDisplayName = window.Globals.GetUserDisplayName(marrReportData[mobjProgressViewData.StudentIndex].FirstName
                , marrReportData[mobjProgressViewData.StudentIndex].LastName
                , marrReportData[mobjProgressViewData.StudentIndex].LoginName)
        }
        else
        {
            strDisplayName = window.Globals.GetUserDisplayName(mobjStudentReportData.FirstName
                , mobjStudentReportData.LastName
                , mobjStudentReportData.LoginName)
        }

        return (
            <>
                <ComponentProgressTitle4StudentView />

                <div className={cssHome.divProgressStudentName}>
                    {strDisplayName}
                </div>
                {/*
                <div className={cssHome.divTESTChineseText}>
                    {"這是中文字 第一課 繁體"}
                </div> 
                <div className={cssHome.divTESTChineseText}>
                    {"这是中文字 第一课 简体"}
                </div>
                */}
            </>
        )
    } // end of RenderProgressTitleMain4StudentViewWrapper

    /*===========================================
    summary: Render Progress 下拉 選單 選項
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderProgressMenuListWrapper(ProgressDropdownIndex, StateBookSeqNo)
    {
        let strBookSeqNo = StateBookSeqNo.toString().PadLeft(2)
        let objProgress = {
            "PrefixName": window.gAppUI.LBL_OverView
        }

        let arrProgress = []
        arrProgress.push(objProgress)
        arrProgress = arrProgress.concat(window.gSession.App.BookDef[strBookSeqNo].Lesson)

        return (
            <div className={cssHome.divProgressMeunItem}>
                {arrProgress.map((Progress, ProgressIndex) =>
                    <MenuItem key={ProgressIndex} className={GetProgressItemCls(ProgressDropdownIndex, ProgressIndex)} 
                            onClick={() => ProgressItemOnTapHandler(ProgressIndex, Progress.ID, StateBookSeqNo)}>
                        {Progress.PrefixName}
                    </MenuItem>
                )}
            </div>
        )
    } // end of RenderProgressMenuListWrapper

    /*===========================================
    summary: Render Progress Title 4 OverView 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderProgressTitleMain4OverViewWrapper(StateProgressViewMode, StateBookSeqNo)
    {
        return (
            <>
                <ComponentProgressTitle4OverView StateProgressViewMode={StateProgressViewMode} />

                <div className={cssHome.divLessonListMain}>
                    <div className={cssHome.btnLessonListDropdown} aria-controls="menuProgress" onClick={(event) => ProgressDropdownOnTapHandler(event)}>
                        <ComponentLessonListText StateProgressViewMode={StateProgressViewMode} StateBookSeqNo={StateBookSeqNo} />
                    </div>

                    <Menu id="menuProgress" ref={mrefProgressDropdown} anchorEl={anchorEl4Progress} keepMounted
                        open={(anchorEl4Progress === null) ? false : true}
                        onClose={ProgressDropdownCloseEventHandler}
                        getContentAnchorEl={null}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}
                        className={cssHome.menuProgress}
                    >
                        {RenderProgressMenuListWrapper(mintProgressDropdownIndex, StateBookSeqNo)}
                    </Menu>
                </div>
            </>
        )
    } // end of RenderProgressTitleMain4OverViewWrapper

    /*===========================================
    summary: Render Progress Title 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderProgressTitleWrapper(StateProgressViewMode)
    {
        let objBlock = null
        if (
            (StateProgressViewMode === ProgressViewModeEnum.OverView) ||
            (StateProgressViewMode === ProgressViewModeEnum.LessonView)
            )
        {
            objBlock = RenderProgressTitleMain4OverViewWrapper(StateProgressViewMode, bookSeqNo)
        }
        else if (StateProgressViewMode === ProgressViewModeEnum.StudentView)
        {
            objBlock = RenderProgressTitleMain4StudentViewWrapper()
        }

        return objBlock
    } // end of RenderProgressTitleWrapper

    /*===========================================
    summary: Render SubContentBottom 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderSubContentBottomWrapper(StateReportTime)
    {
        if (StateReportTime > 0)
        {
            return (
                <div className={GetSubContentBottomCls()}>
                    {RenderProgressTitleWrapper(progressViewMode)}

                    {RenderVolumeMainWrapper(bookSeqNo)}

                    {RenderProgressViewWrapper(progressViewMode, bookSeqNo)}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderSubContentBottomWrapper

    /*===========================================
    summary: Render Last Access 的顯示
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function RenderLastAssignmentWrapper()
    {
        // console.log(COMP_NAME + ".RenderLastAssignmentWrapper")

        let strLastAssignmentTitle = ""
        let blnIsTeacher = false;

        if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            blnIsTeacher = true;
            strLastAssignmentTitle = window.gAppUI.LBL_LastAssignmentCompletion
        }
        else
        {
            // Student or Personal 個人帳號
            blnIsTeacher = false;
            strLastAssignmentTitle = window.gAppUI.LBL_LastAssignmentScore
        }

        return (
            <div className={cssHome.divLastAssignmentMain} onClick={() => LastAssignmentOnTapHandler(mintAccountRole)}>
                <div className={cssHome.divLastAssignmentTitle}>
                    {strLastAssignmentTitle}
                </div>
                <div className={cssHome.divViewMoreDetails}>
                    {window.gAppUI.LBL_ViewMoreDetails}
                </div>
                <div className={cssHome.divRunningPieChart}>
                    <RunningPieChart IsTeacher={blnIsTeacher} Average={average4RPC} />
                </div>
            </div>
        )
    } // end of RenderLastAssignmentWrapper

    /*===========================================
    summary: Render Last Access 的顯示
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function RenderLastAccessWrapper(StateDashboardCheckTime)
    {
        // console.log(COMP_NAME + ".RenderLastAccessWrapper: ", StateDashboardCheckTime)

        let objBlock = null
        if (
            (StateDashboardCheckTime === 0) ||
            (mobjDashboardDisplay.PrefixName === window.gAppUI.LBL_NA)
            )
        {
            objBlock = <ComponentLastAccess4NA PrefixName={mobjDashboardDisplay.PrefixName} />
        }
        else
        {
            objBlock = <ComponentLastAccess LastAccessData={mobjDashboardDisplay} />
        }

        return objBlock
    } // end of RenderLastAccessWrapper

    /*===========================================
    summary: Render Bulletin Miscellaneous 的顯示
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function RenderBulletinMiscellaneousWrapper(Assignment, AssignmentIndex, DueDate)
    {
        // console.log(COMP_NAME + ".RenderBulletinMiscellaneousWrapper: ", Assignment)

        let objButtonBlock = null

        if (
            (typeof (Assignment.LUCatSeqNo) !== 'undefined') &&
            (Assignment.LUCatSeqNo !== null) &&
            (Assignment.LUCatSeqNo !== -1)
            )
        {
            objButtonBlock = <ComponentBulletinMiscellaneous4Assignment Assignment={Assignment} AssignmentIndex={AssignmentIndex} DueDate={DueDate} />
        }
        else
        {
            objButtonBlock = <ComponentBulletinMiscellaneous4Message Assignment={Assignment} />
        }

        return (
            <div className={cssHome.divBulletinMiscellaneousMain}>
                {objButtonBlock}
            </div>
        )
    } // end of RenderBulletinMiscellaneousWrapper

    /*===========================================
    summary: Render Bulletin Row 的顯示
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function RenderBulletinRowMainWrapper(Assignment, AssignmentIndex, AccountRole)
    {
        let datNow = new Date()

        // 截止時間         // Server讀出來的時間 轉 顯示時間
        let datDue = new Date(Assignment.DueDate.replace(/-/g, '/'))
        datDue.setMinutes(datDue.getMinutes() + window.gSession.App.MinutesOffset)

        let objBulletinRowBlock = ""

        if (AccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            objBulletinRowBlock = <ComponentBulletinRow4Teacher Assignment={Assignment} AssignmentIndex={AssignmentIndex} NowDate={datNow} DueDate={datDue} />
        }
        else if (AccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
        {
            objBulletinRowBlock = <ComponentBulletinRow4Student Assignment={Assignment} AssignmentIndex={AssignmentIndex} NowDate={datNow} DueDate={datDue} />
        }
        else
        {
            // Personal 個人帳號 無Class
            objBulletinRowBlock = <ComponentBulletinRow4Personal Assignment={Assignment} AssignmentIndex={AssignmentIndex} />
        }

        return (
            <>
                {objBulletinRowBlock}

                {RenderBulletinMiscellaneousWrapper(Assignment, AssignmentIndex, datDue)}
            </>
        )
    } // end of RenderBulletinRowMainWrapper

    /*===========================================
    summary: Render Bulletin Content 的顯示
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function RenderBulletinContentWrapper()
    {
        return (
            <div className={cssHome.divBulletinContent}>
                {marrAssignmentSource.map((Assignment, AssignmentIndex) =>
                    <div key={AssignmentIndex} className={cssHome.divBulletinRow}>
                        {RenderBulletinRowMainWrapper(Assignment, AssignmentIndex, mintAccountRole)}
                    </div>
                )}
            </div>
        )
    } // end of RenderBulletinContentWrapper

    /*===========================================
    summary: Render Bulletin 的顯示
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function RenderBulletinWrapper(StateUpdateAssignmentTime)
    {
        if (StateUpdateAssignmentTime > 0)
        {
            return (
                <div className={cssHome.divBulletinMain}>
                    <ComponentBulletinTitle />

                    <ComponentBulletinAddButton AccountRole={mintAccountRole} />

                    {RenderBulletinContentWrapper()}
                </div>
            )
        }
        else
        {
            return (
                <div className={cssHome.divBulletinMain}>
                    <ComponentBulletinTitle />
                </div>
            )
        }
    } // end of RenderBulletinWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <div className={cssHome.divContent}>
                <div className={GetSubContentTopCls()}>
                    {RenderBulletinWrapper(updateAssignmentTime)}
                    <div className={cssHome.divLastMain}>
                        {RenderLastAccessWrapper(dashboardCheckTime)}
                        {RenderLastAssignmentWrapper()}
                    </div>
                </div>

                {RenderSubContentBottomWrapper(reportTime)}

                {RenderProgressMemoAreaWrapper(reportTime)}
            </div>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        if (!mblnIfNeed2GoToApplicationHomePage)
        {
            return (
                <>
                    <div className={cssHome.divMain}>

                        <ToolBarTopUnit Title={window.gAppUI.LBL_Home}
                            ButtonType={window.gButtonTypeEnum.Home}
                            CallbackRef={ComponentCallback} />

                        {RenderContentWrapper()}

                        <ToolBarBottomUnit ButtonType={window.gButtonTypeEnum.Home}
                            History={props.history}
                            CallbackRef={ComponentCallback} />
                    </div>

                    {RenderPCLWindowWrapper(isShowPCLWindow)}
                    {RenderTermsOfUseWindowWrapper(isShowTermsOfUseWindow)}
                    {RenderBulletinMsgBoxWrapper(isShowBulletinMsgBox)}
                    {RenderOpenWebWindowWrapper(isShowOpenWebWindow)}
                    {RenderBCAppsWindowsWrapper(isShowBCAppsWindows)}
                    {RenderLUAssignWrapper(isShowLUAssign)}
                    {RenderAssignEditWrapper(isShowAssignEdit)}
                    {RenderAssignReportWrapper(isShowAssignReport)}
                    {RenderAssignmentPracticeSheetWrapper(isShowAssignmentPracticeSheet)}

                    {RenderSubscriptionReminderWrapper(isShowSubscriptionReminder)}
                    {RenderEmailVerifiedWrapper(isShowEmailVerified)}
                    {RenderEmailVerifiedSuccessWrapper(isShowEmailVerifiedSuccess)}
                    {/* {RenderDownloadAnotherAppWindowWrapper()} */}

                    <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
                    <AlertWindow ShowAlert={showAlert} AlertObject={alertObject} HideAlertFuncRef={HideAlert} />
                    <CredentialMultiInWindow ShowCredentialMultiIn={showCredentialMultiIn} 
                        CredentialMultiInArguments={credentialMultiInArguments}/>
                </>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default Home